export default {
  // signin
  'sign.title': 'Đăng nhập',
  'signIn.subtitle': 'Dịch vụ ERP cho nhà thầu',
  'country.korea': 'Hàn Quốc',
  'country.vietnam': 'Việt Nam',
  'seller.businessNumber': 'Mã số thuế',
  'sign.phone.message': 'Nhập mã số thuế (không dấu cách)',
  'staff.no': 'Mã số nhân viên',
  'error.BLANK_PHONE': 'Nhập mã số thuế',
  'error.BLANK_STAFF_ID': 'Nhập mã số nhân viên',
  'error.BLANK_PASSWORD': 'Nhập mật khẩu',
  'error.INVALID_STAFF_ID': 'Tên đăng nhập của nhân viên không tồn tại',
  'error.INVALID_PHONE_NUMBER': 'Tên đăng nhập không tồn tại',
  'error.INVALID_PASSWORD': 'Sai Mật khẩu',
  'error.INACTIVE_STAFF_ID': 'Nhân viên này không còn quyền hoạt động',
  'common.password': 'Mật khẩu',
  'partner.password': 'Mật khẩu',
  'sign.password.message': 'Nhập mật khẩu',
  'signIn.login.idSave': 'Lưu tên đăng nhập',
  'signIn.join.1': 'Chào mừng bạn đến với ứng dụng Naya\n',
  'signIn.join.2': 'Đăng ký thành viên',
  'signIn.join.3': 'Bạn đã là thành viên của Naya?',
  'signIn.join.4': 'Đăng nhập',
  'signIn.extra.1': 'Hoặc',
  'signIn.extra.TYPE_ADMIN': 'Đăng nhập bằng tài khoản nhân viên',
  'signIn.extra.TYPE_STAFF': 'Đăng nhập bằng tài khoản công ty',
  'error.BLANK_BUSINESS_NUMBER': 'Nhập mã số thuế',
  'error.BLANK_CONFIRM_PASSWORD': 'Xác nhận mật khẩu',
  'error.BLANK_COMPANY_NAME': 'Nhập tên công ty',
  'error.BLANK_MANAGER_NAME': 'Nhập tên',
  'error.BLANK_MANAGER_PHONE': 'Nhập số điện thoại',
  'error.FALSE_AGREE_PRIVACY_USAGE': 'Đồng ý về việc xử lý và cung cấp dữ liệu cá nhân cho bên thứ ba.',
  'error.IS_NOT_SAME_PASSWORD': 'Mật khẩu không chính xác',
  'error.PASSWORD_TOO_SHORT': 'Mật khẩu phải từ 6 ký tự trở lên',
  // 다름: "이미 가입된 사업자번호입니다.\n나야 CS문의 1644-4908 또는 카카오톡 '나야 NAYA'" -> '이미 가입된 사업자번호입니다.'
  'error.ALREADY_JOINED': 'Mã số thuế này đã được đăng ký rồi',
  'recruitment.companyName': 'Tên công ty',
  'recruitment.companyName.placeholder': 'Nhập tên công ty',
  'signIn.join.managerName': 'Tên',
  'signIn.join.managerName.placeholder': 'Nhập tên',
  'signIn.join.managerPhone': 'Số điện thoại',
  // 다름: '(-)제외 휴대전화번호를 입력해주세요' -> '휴대전화번호를 입력해주세요'
  'signIn.join.managerPhone.placeholder': 'Nhập số điện thoại',
  'common.password2': 'Xác nhận mật khẩu',
  'signIn.join.agreePrivacyUsage': 'Đồng ý về việc xử lý và cung cấp dữ liệu cá nhân cho bên thứ ba (bắt buộc)',
  'signIn.join.subtitle': 'Nhập thông tin để đăng ký dịch vụ',
  'signIn.appDownload.google': 'Google Play',
  'signIn.appDownload.apple': 'App Store',
  'signIn.join.button': 'Đăng ký thành viên thành công',
  'signIn.join.complete.message': 'Xin chào. {companyName}!\n Bạn đã đăng ký thành viên thành công',
  'signIn.join.complete.button': 'Bắt đầu sử dụng',
  'error.COMMON_SIGN_IN': 'Tên đăng nhập (mã số thuế) hoặc mật khẩu không chính xác.\nVui lòng nhập đúng tên đăng nhập và mật khẩu của bạn',
  'error.defaultError': 'Không kết nối được với máy chủ',
  'sign.join': 'Đăng ký thành viên',
  'signIn.vi.phone.placeholder': 'Mã số thuế hoặc số điện thoại',
  'signIn.vi.phone.focus': '* Công ty sử dụng mã số thuế, cá nhân sử dụng số điện thoại',
  'error.COMMON_SIGN_IN_VI': 'ID hoặc mật khẩu không đúng. Vui lòng nhập chính xác.',
  'signIn.join.select.type': 'Vui lòng chọn loại hình đăng ký',
  'signIn.join.company': 'Công ty',
  'signIn.join.company.sub': 'Pháp nhân và doanh nghiệp',
  'signIn.join.personal': 'Cá nhân',
  'signIn.join.personal.sub': 'Cá nhân không đăng ký GPKD',
  'signIn.join.staff.method': 'Cách đăng ký thành viên nhân viên',
  'signIn.join.staff.sub':
    "Nhân viên có thể sử dụng dịch vụ qua lời mời từ thành viên quản trị.\n\n1. Đăng nhập vào trang chủ ERP NAYA.\n2. Nhấn vào hồ sơ của tôi ở góc trên bên phải, sau đó nhấn 'Cài đặt'.\n3. Nhấn vào 'Tạo mới nhân viên phụ trách' trong phần 'Quản lý nhân viên nội bộ'\n4. Sau khi nhập thông tin nhân viên, nhấn 'Đăng ký hoàn thành'\n\n*Sau khi tạo, mỗi nhân viên sẽ được cấp một ID. Khi nhân viên đăng nhập, chỉ cần nhập ID được cấp.",
  'signIn.join.phone.verify': 'Xác thực số điện thoại ',
  'signIn.join.phone.message': 'Vui lòng nhập số điện thoại',
  'signIn.join.phone.verify.number': 'Mã xác thực',
  'signIn.join.phone.verify.send': 'Gửi mã xác thực',
  'signIn.join.phone.verify.input.placeholder': 'Vui lòng nhập mã xác thực gồm 6 chữ số.',
  'signIn.join.phone.verify.resend': 'Gửi lại ',
  'signIn.join.phone.error.verify.notMatch': 'Mã xác thực không khớp',
  'signIn.join.phone.error.verify.send': 'Mã xác thực đã được gửi',
  'signIn.join.phone.error.verify.resend': 'Mã xác thực đã được gửi lại',
  'signIn.join.phone.verify.complete': 'Xác thực số điện thoại đã hoàn tất.',
  'error.WRONG_FORMAT_PHONE': 'Vui lòng kiểm tra số điện thoại',
  'signIn.join.phone.verify.complete.word': 'Xong',
  'signIn.join.referral': 'Kênh đăng ký (Không bắt buộc)',
  'signIn.join.referral.placeholder': 'Bạn biết đến App NAYA qua đâu?',
  'signIn.join.email': 'Email (Không bắt buộc)',
  'signIn.join.email.placeholder': 'Vui lòng nhập email',
  'signIn.join.referral.facebook': 'Facebook',
  'signIn.join.referral.instagram': 'Instagram',
  'signIn.join.referral.referral': 'Người quen giới thiệu',
  'signIn.join.referral.referral.label': 'Người quen giới thiệu (nhập trực tiếp)',
  'signIn.join.referral.referral.placeholder': 'Vui lòng nhập tên hoặc tên công ty của người giới thiệu',
  'signIn.join.referral.etc.label': 'Khác (nhập trực tiếp)',
  'signIn.join.referral.etc': 'Khác',
  'signIn.join.referral.check': 'Kiểm tra trùng lặp',
  'signIn.join.referral.check.message': 'MST có thể đăng ký thành viên',
  'error.BUSINESS_NUMBER_NOT_VALID': "Vui lòng nhấn 'Kiểm tra trùng lặp' mã số thuế",
  'error.BUSINESS_NUMBER_EXISTS': 'MST này đã được đăng ký',
  'error.WRONG_FORMAT_BUSINESS_NUMBER': 'Vui lòng nhập MST hợp lệ',
  'signIn.join.managerName2': 'Tên người phụ trách',
  'signIn.join.phone.verify.send.message': 'Mã xác thực đã được gửi',
  'signIn.join.phone.verify.resend.message': 'Mã xác thực đã được gửi lại',
  'signIn.join.phone.verify.complete.message': 'Xác thực số điện thoại đã hoàn tất.',
  'signIn.login.findPassword': 'Tìm mật khẩu',
  'signIn.join.5': 'Bạn có nhớ mật khẩu không?',
  'signIn.join.phone.verify.title': 'Xác thực thông tin doanh nghiệp',
  'signIn.join.phone.verify.sub': 'Vui lòng nhập MST và SĐT đã sử dụng khi\nđăng ký tài khoản để xác minh danh tính của bạn.',
  'signIn.join.findPassword.title': 'Đặt lại mật khẩu',
  'signIn.join.findPassword.sub': 'Nhập mật khẩu mới',
  'signIn.join.findPassword.businessNumber': 'Mã số thuế',
  'error.signIn.join.findPassword.businessNumber': 'Vui lòng kiểm tra MST và số điện thoại',
  'signIn.join.phone.verify.complete.message.findPassword': 'Xác thực thông tin doanh nghiệp đã hoàn tất.',
  'signIn.join.findPassword.complete.title': 'Cài đặt mật khẩu hoàn tất',
  'signIn.join.findPassword.complete.sub': 'Vui lòng quay lại màn hình đăng nhập\nvà đăng nhập bằng mật khẩu mới',
  'signIn.join.company.2': 'Đăng ký thành viên công ty',
  'signIn.join.personal.2': 'Đăng ký thành viên cá nhân',
  'error.PHONE_NUMBER_EXISTS': 'Số điện thoại này đã được đăng ký',
  'signIn.join.phone.verify.complete.message.findPassword.freelancer': 'Xác thực thông tin thành viên đã hoàn tất.',
  'signIn.join.consult': 'Liên hệ',
  'consult.customer.create.phone': 'Số điện thoại',
  'error.password.validate': '6~15 ký tự bao gồm chữ, số và các ký tự đặc biệt',
  'error.password.notMatch': 'Mật khẩu không chính xác',
  'signIn.findPassword.staff.method': 'Cách khôi phục mật khẩu nhân viên',
  'signIn.findPassword.staff.sub':
    "Có thể thay đổi mật khẩu thông qua thành viên quản trị.\n\n1. Đăng nhập vào trang chủ ERP NAYA.\n2. Nhấn vào hồ sơ của tôi ở góc trên bên phải, sau đó nhấn 'Cài đặt'.\n3. Nhấn vào nhân viên mà bạn muốn thay đổi mật khẩu trên trang 'Quản lý nhân viên nội bộ' ở tab trên cùng.\n4. Sau khi nhấn 'Sửa', nhấn 'Thay đổi mật khẩu' để có thể thiết lập mật khẩu mới.",

  // todo 기능개발 후 번역요청
  // 'signIn.join.from': '(선택) 가입경로',
  // 'signIn.join.from.placeholder': '어떻게 나야를 알게 되었나요?',
  // 'signIn.join.from.facebook': '페이스북',
  // 'signIn.join.from.instagram': '인스타그램',
  // 'signIn.join.from.referral': '지인 추천(직접입력)',
  // 'signIn.join.from.etc': '기타(직접입력)',

  // sidebar & header
  'field.all': 'Tất cả công trình',
  'common.logout': 'Đăng xuất',
  'sidebar.material.dashboard': 'Trang chủ',
  'sidebar.material.field': 'Quản lý công trình',
  'title.field': 'Quản lý\ncông trình',
  'consult.managingField': 'Quản lý công trình',
  'title.setting': 'Cài đặt',
  'sidebar.field.title': 'Công trình của tôi',
  'sidebar.field.createButton': 'Công trình mới',
  'sidebar.field.input.placeholder': 'Tìm tên, địa chỉ công trình',
  'sidebar.material.field.create': 'Tạo Công trình',
  'sidebar.material.field.modify': 'Sửa Công trình',
  'popup.modifyField': 'Sửa Công trình',
  'field.name': 'Tên công trình',
  'field.workLog.detail.2': 'Tên công trình',
  'recruitment.portfolios.fieldName': 'Tên công trình',
  'consult.customer.create.fieldName.placeholder': 'Nhập tên công trình',
  'common.address': 'Địa chỉ',
  'seller.address': 'Địa chỉ',
  'sidebar.field.update.address.placeholder': 'Nhập địa chỉ',
  'sidebar.field.update.dateConstructStart.placeholder': 'Ngày bắt đầu',
  'sidebar.field.update.dateConstructEnd.placeholder': 'Ngày kết thúc',
  'button.searchAddress': 'Tìm địa chỉ',
  'consult.button.customer.address': 'Tìm địa chỉ',
  'recruitment.portfolios.date': 'Tiến độ thi công',
  'address.popup.search.placeholder': '예) 판교역로 166, 분당 주공, 백현동 532',
  'address.popup.empty.title': 'tip',
  'address.popup.empty.sub': '아래와 같은 조합으로 검색을 하시면 더욱 정확한 결과가 검색됩니다.',
  'address.popup.empty.example.title.1': '도로명 + 건물번호',
  'address.popup.empty.example.sub.1': '예) 판교역로 166, 제주 첨단로 242',
  'address.popup.empty.example.title.2': '지역명(동/리) + 번지',
  'address.popup.empty.example.sub.2': '예) 백현동 532, 제주 영평동 2181',
  'address.type.old': '지  번',
  'address.type.new': '도로명',
  'button.cancel': 'Hủy',
  'profile.password.cancelled': 'Hủy',
  'delivery.logiSpot.status.CANCELLED': 'Hủy',
  'popup.customer.delete.cancel': 'Hủy',
  'fileUpload.labelTapToCancel': 'Hủy',
  'common.done': 'Hoàn tất',
  'title.common': 'Naya',
  'sidebar.field.empty.list': 'Không có công trình nào tương ứng với ',
  'consult.customer.create.address2.placeholder': 'Nhập địa chỉ chi tiết',
  'consult.customer.create.error.address2': 'Nhập địa chỉ chi tiết',
  'order.add.address2.placeholder': 'Nhập địa chỉ chi tiết',
  'field.contract.placeholder.address2': 'Nhập địa chỉ chi tiết',
  'field.dateConstruct': 'Tiến độ thi công',
  'field.guide.text': 'Bạn có thể thay đổi công trình tại đây',
  'field.add.update.address.search': 'Tìm địa chỉ',
  'field.add.update.customer.connect': 'Kết nối khách hàng',
  'field.add.update.customer.connect.button': '+ Kết nối khách hàng',
  'field.add.update.customer.connect.sub': '* Khi đăng ký, chỉ có Báo cáo công trình, Phòng chat và Tài liệu đính kèm được chia sẻ.',
  'field.add.update.constructStatus.placeholder': 'Vui lòng lựa chọn tình trạng',
  'field.add.update.constructStatus': 'Tình trạng',
  'consult.constructStatus.CONSULTING': 'Đang tư vấn',
  'consult.constructStatus.WORKING': 'Đang thi công',
  'consult.constructStatus.COMPLETE': 'Hoàn thành',
  'consult.constructStatus.DUMMY': 'Tạm dừng',
  'field.add.update.spaceType': 'Kiểu công trình',
  'field.add.update.spaceType.resident': 'Nhà ở',
  'field.add.update.spaceType.commercial': 'Cửa hàng',
  'field.add.update.cancel.create.title': 'Bạn có muốn dừng việc tạo công trình không?',
  'field.add.update.cancel.title': 'Bạn có muốn dừng việc cài đặt công trình không?',
  'field.add.update.staff.placeholder': 'Vui lòng chọn nhân viên phụ trách ',
  'field.add.update.spaceType.placeholder': 'Vui lòng thiết lập kiểu công trình (Nhà ở/Kinh doanh)',
  'header.notification.title': 'Thông báo',
  'sidebar.notification.allRead': 'Đánh dấu đã đọc tất cả',
  // only korean
  'sidebar.sales.management': '영업관리',
  'sidebar.material.management': '발주 관리',
  'sidebar.material.budget': '자재예산관리',
  'sidebar.field.edit': 'Chỉnh sửa',
  'sidebar.field.create': '+ Tạo Công trình',
  'sidebar.field.edit.title': 'Chỉnh sửa công trình',
  'sidebar.field.edit.storage': 'Kho lưu trữ',
  'sidebar.field.edit.storage.title': 'Bạn muốn ẩn công trình đã chọn vào kho lưu trữ?',
  'sidebar.field.edit.storage.sub': 'Có thể khôi phục công trình đã ẩn trong kho lưu trữ',
  'sidebar.field.edit.storage.button': 'Ẩn',
  'sidebar.field.edit.storage.success': '✅ Đã ẩn {count} công trình trong kho lưu trữ',
  'sidebar.field.edit.storage.restore': 'Khôi phục',
  'sidebar.field.edit.storage.restore.title': 'Bạn muốn khôi phục công trình đã ẩn?',
  'sidebar.field.edit.storage.restore.sub': 'Công trình được khôi phục sẽ hiển thị lại trong danh sách',
  'sidebar.field.edit.storage.empty': 'Không có công trình nào bị ẩn',
  'sidebar.field.year': 'Theo năm thi công',
  'sidebar.field.edit.hide': 'Ẩn công trình',
  'sidebar.field.edit.storage.restore.success': '✅ Công trình này đã được khôi phục',
  // todo: 번역 요청
  'internal.notice.title': 'Thông báo nội bộ',
  'internal.notice.title.placeholder': 'Tìm kiếm đề mục',
  'internal.notice.field.no': 'Thứ tự',
  'internal.notice.field.title': 'Đề mục',
  'internal.notice.field.title.placeholder': 'Nhập đề mục',
  'internal.notice.field.image': 'Đính kèm hình ảnh',
  'internal.notice.field.image2': 'Đính kèm hình ảnh',
  'internal.notice.field.image.sub': 'Đính kèm tối đa 10 hình ảnh (png, jpg)',
  'internal.notice.field.body': 'Soạn nội dung',
  'internal.notice.field.body.placeholder': 'Vui lòng nhập thông tin nội bộ cần truyền đạt.\nKhi nhập, nên bao gồm đối tượng, nội dung chính, lịch trình ...',
  'internal.notice.field.view': 'Lượt xem',
  'internal.notice.field.more': 'Xem thêm',
  'internal.notice.field.file': 'Đính kèm file',
  'internal.notice.empty.title': 'Không có thông báo được nhập',
  'internal.notice.empty.button': 'Soạn thông báo nội bộ >',
  'internal.notice.detail.title': 'Chi tiết thông báo',
  'internal.notice.detail.back': 'Quay lại danh sách',
  'internal.notice.create.title': 'Soạn thông báo mới',
  'internal.notice.create.cancel': 'Hủy soạn',
  'internal.notice.create.publish': 'Đăng tải',
  'internal.notice.delete.title': 'Bạn có muốn xóa thông báo không?',
  'internal.notice.delete.content': 'Khi đã xóa, bạn sẽ không thể phục hồi lại được.\nBạn có chắc chắn muốn xóa không?',
  'internal.notice.delete.success': 'Đã xóa',
  'internal.notice.cancel.title': 'Nội dung chưa lưu sẽ bị mất.\nBạn có muốn hủy không?',
  'internal.notice.modify.title': 'Sửa thông báo nội bộ',
  'internal.notice.modify.cancel': 'Hủy sửa',
  'internal.notice.modify.publish': 'Lưu',
  'internal.notice.modify.required': 'Tiêu đề và nội dung là các mục bắt buộc.',
  'internal.notice.modify.publish.title': 'Bạn có muốn đăng bài viết này không?',
  'internal.notice.modify.publish.sub': 'Sau khi tải lên, bạn có thể chỉnh sửa và xóa bài viết.',
  'internal.notice.modify.publish.button': 'Đăng tải',
  'internal.notice.modify.publish.success': 'Xong',
  'internal.notice.modify.update.success': 'Xong',

  // dashboard
  'dashboard.all.date.noDate': 'Từ thời gian',
  'dashboard.all.date.noDate.end': 'Đến thời gian',
  'dashboard.field.revenue.total.1': 'Tổng doanh thu',
  'dashboard.field.expenses.total': 'Tổng chi phí',
  'dashboard.field.profit.sum': 'Lợi nhuận tích lũy',
  'dashboard.field.profit.margin.average': 'Tỷ suất lợi nhuận trung bình',
  'dashboard.all.ledger.graph.table': 'Lợi nhuận\ncông trình',
  'dashboard.all.sort.graph.amountDesc': 'Lợi nhuận cao nhất',
  'dashboard.all.sort.graph.saleDesc': 'Doanh số cao nhất',
  'dashboard.all.sort.graph.latest': 'Theo thứ tự cập nhật',
  'dashboard.all.ledger.collection.table': 'Khoản phải thu',
  'dashboard.all.sort.collection.amountDesc': 'Theo thứ tự số tiền cao nhất',
  'dashboard.all.sort.collection.amountAsc': 'Theo thứ tự số tiền thấp nhất',
  'dashboard.all.sort.collection.latest': 'Theo thứ tự cập nhật',
  'dashboard.all.ledger.table': 'Thứ tự công trình theo lợi nhuận',
  'dashboard.all.sort.amountDesc': 'Lợi nhuận cao nhất',
  'dashboard.all.sort.amountAsc': 'Lợi nhuận thấp nhất',
  'dashboard.all.sort.latest': 'Theo thứ tự cập nhật',
  'dashboard.all.header.target': 'Tỷ lệ hoàn thành mục tiêu',
  'dashboard.all.ledger.noData': 'Không có thông tin sổ sách kế toán công trình này',
  'dashboard.all.date.title': 'Lọc theo thời gian',
  'dashboard.all.date.confirm': 'Cài đặt hoàn tất',
  'dashboard.all.date.header': 'Chọn thời gian',
  'dashboard.all.date.header.tooltip': 'Nếu không cài đặt ngày hoàn công\n thì sẽ phải ghi chú lại.\nViệc thi công kéo dài sang năm thứ hai\nsẽ được thể hiện dựa trên năm kết thúc.',
  'dashboard.all.date.button.all': 'Tất\ncả',
  'dashboard.field.all': 'Tất cả',
  'search.all': 'Tất cả',
  'transactions.date.all': 'Tất cả',
  'consult.constructStatus.ALL': 'Tất cả',
  'consult.staff.ALL': 'Tất cả',
  'dashboard.all.date.button.year.this': 'Năm\nnay',
  'dashboard.all.date.button.year.last': 'Năm\nngoái',
  'dashboard.all.date.field.all': 'Tất cả công trình',
  'dashboard.all.date.field.selected': 'Công trình đã chọn',
  'dashboard.all.date.field.no.date': 'Cài đặt ngày hoàn công',
  'common.allShow.true': 'Xem thêm',
  'common.showMore': 'Xem thêm',
  'dashboard.tooltip.revenueCard': 'Tổng doanh thu đã nhập',
  'dashboard.tooltip.expensesCard': 'Tổng chi phí đã nhập',
  'dashboard.tooltip.profitLossCard': 'Số tiền còn lại sau tổng doanh thu trừ tổng chi phí',
  'dashboard.tooltip.profitMarginCard.sum': 'Tỷ lệ lợi nhuận lũy kế trên tổng doanh thu',
  'common.allShow.false': 'Đóng',
  'common.close': 'Đóng',
  'work.accountancy.constructionFinishDate': 'Ngày hoàn công',
  'sidebar.material.field.modify.date': 'Sửa tiến độ thi công',
  'dashboard.field.profit': 'Lợi nhuận\ncông trình',
  'dashboard.field.profit.1': 'Lợi nhuận',
  'dashboard.field.profit.2': 'công trình',
  'dashboard.field.current.profit': 'Lợi nhuận công trình',
  'dashboard.field.profit.margin': 'Tỷ lệ lợi nhuận',
  'dashboard.field.target.profit': 'Lợi nhuận mục tiêu',

  // dashboard/field
  'common.target': 'Mục tiêu',
  'common.under': 'Chưa hoàn thành',
  'common.over': 'Vượt quá',
  'budget.quantity.minus': 'Vượt quá',
  'dashboard.field.over.budget': 'Vượt quá',
  'common.none': 'Không có',
  'dashboard.tooltip.profitMarginCard': 'Tỷ lệ lợi nhuận công trình trên tổng doanh thu',
  'dashboard.field.input.update.account.book': 'Thu chi',
  'dashboard.field.sales': 'Doanh thu',
  'dashboard.field.expenses': 'Chi phí',
  'dashboard.field.collections': 'Khoản thu',
  'dashboard.tooltip.receivables': 'Số tiền còn lại sau tổng doanh thu trừ tổng khoản thu',
  'dashboard.tooltip.currentProfit': 'Số tiền còn lại sau tổng doanh thu trừ tổng chi phí',
  'dashboard.field.revenue.total.2': 'Tổng doanh thu',
  'dashboard.field.receivables': 'Khoản phải thu',
  'dashboard.field.receivables.total': 'Tổng các khoản phải thu',
  'dashboard.field.expenses.budget': 'Ngân sách chi',
  'dashboard.field.under.budget': 'Còn lại',
  'budget.quantity.plus': 'Còn lại',
  'dashboard.field.expenses.budget.total': 'Tổng ngân sách',
  'dashboard.field.material.expenses': 'Chi phí vật tư',
  'dashboard.field.labor.expenses': 'Chi phí nhân công/Thuê ngoài',
  'dashboard.field.extra.expenses': 'Chi phí khác',
  'dashboard.field.budget.comparison': 'So với ngân sách',
  'dashboard.field.management': 'Chức năng quản lý công trình',
  'dashboard.field.chat': 'Trò chuyện',
  'dashboard.field.chat.inner': 'Phòng chat\nnội bộ',
  'dashboard.field.chat.customer': 'Phòng chat\nkhách hàng',
  'dashboard.field.file': 'Tài liệu\nđính kèm',
  'dashboard.field.report': 'Báo cáo\ncông trình',
  'dashboard.field.staff': 'Quản lý\nnhân viên',
  'dashboard.field.consult': 'Quản lý\nkhách hàng',
  'dashboard.field.calendar': 'Quản lý tiến độ',
  'dashboard.field.profile': 'Thông tin\ncủa tôi',
  'field.info.update': 'Sửa thông tin',
  'field.info.staff': 'Nhân viên phụ trách',
  'dashboard.field.info.staff': 'Người\nphụ trách',
  'field.info.construction.period': 'Thời gian thi công',
  'dashboard.field.info.construction.period': 'Lịch trình',
  'field.info.memo': 'Ghi chú khác',
  'dashboard.field.info.memo': 'Ghi chú',
  'field.info': 'Thông tin\ncông trình',
  'dashboard.field.account.book.empty': 'Tạo thu chi công trình',
  'dashboard.field.account.book.sales.empty': 'Tạo doanh thu',
  'dashboard.field.account.book.expenses.empty': 'Tạo chi phí',
  'dashboard.field.account.book.collections.empty': 'Tạo khoản cần thu',
  'dashboard.field.account.book': 'Thu chi',
  'dashboard.workLogs.empty.button': 'Tạo báo cáo công trình',
  'dashboard.salesNotes.empty.button': 'Tạo ghi chú công trình',

  // field/work-logs
  'field.title.log.simple': 'Báo cáo công trình',
  'field.workLog.add': 'Tạo báo cáo',
  'field.workLog.empty.message': 'Chưa có báo cáo công trình nào.\nBắt đầu tạo báo cáo công trình!',
  'common.fill.blank': 'Nhập hạng mục',
  'title.field.workLogs.add': 'Tạo báo cáo công trình',
  'title.field.workLogs.update': 'Sửa báo cáo công trình',
  'field.workLogs.name': 'Không gian thi công',
  'field.workLogs.content': 'Nội dung thi công',
  'err.image.FileTooLarge': 'Dung lượng file quá lớn',
  'field.workLogs.name.list.placeholder': 'Chọn không gian hiện có',
  'field.workLogs.name.list.empty': 'Chưa có không gian nào được tạo',
  'field.workLogs.name.placeholder': 'Tạo thông tin không gian thi công',
  'title.field.workLogs': 'Báo cáo công trình',
  'title.field.workLogs.comment.add': 'Viết bình luận',
  'field.workLogs.date': 'Ngày thi công',
  'field.workLogs.image': 'Hình ảnh công trình',
  'button.add': 'Thêm',
  'button.close': 'Đóng',
  'popup.customer.detailInfo.noty.cancel': 'Đóng',
  'button.modify': 'Sửa',
  'button.delete': 'Xóa',
  'sidebar.material.field.detail': 'Chi tiết công trình',
  'field.date': 'Ngày',
  'common.date': 'Ngày',
  'recruitment.companyHistories.date': 'Ngày',
  'image.limit.message': 'Thêm được tối đa 30 ảnh',
  'dropzone.noty.free': 'Kéo hoặc bấm để tải ảnh lên',
  'message.delete': 'Bạn đồng ý xóa?',
  'field.workLogs.add.button': 'Tạo báo cáo công trình mới',
  'field.workLogs.empty.1': 'Không có báo cáo công trình được tạo',
  'field.workLogs.empty.2': 'Bạn {name} vui lòng nhập báo cáo đầu tiên nhé!',
  'field.workLogs.empty.button': 'Tạo báo cáo công trình mới',
  'field.workLogs.comment': 'Bình luận',
  'field.workLogs.name.all': 'Toàn bộ không gian',
  'field.workLogs.comment.placeholder': 'Nhập bình luận',
  'field.workLogs.comment.empty': 'Chưa có bình luận được nhập',
  'field.workLogs.add.popup.title': 'Nhập báo cáo công trình',
  'field.workLogs.add.popup.content.title': 'Không gian',
  'field.workLogs.add.popup.content.date': 'Ngày báo cáo',
  'field.workLogs.add.popup.content.space.placeholder': 'Chọn không gian',
  'field.workLogs.add.popup.content.space.add': '+ Thêm không gian',
  'field.workLogs.add.popup.content.space.name.placeholder': 'Nhập tên không gian',
  'field.workLogs.add.popup.content.update': 'Sửa báo cáo công trình',
  'field.workLogs.delete.confirm': 'Bạn thật sự muốn xóa\nbáo cáo công trình?',
  'field.workLogs.delete.success': 'Đã xóa ',
  'field.workLogs.image.error': 'Vui lòng thêm ít nhất một ảnh thực tế của công trình.',
  'field.workLogs.content.short': 'Xem tóm tắt',
  'field.workLogs.content.long': 'Xem chi tiết',
  'field.workLogs.list': 'Danh sách',
  'field.workLogs.current': 'Đang xem',

  // field/comment
  'field.comment.noty': 'Phòng chat mở (tất cả nhân viên đều xem được)',
  'field.comment.noty.true': 'Bật Cho phép thông báo',
  'field.comment.noty.false': 'Tắt Cho phép thông báo',
  'field.comment.noty2': 'Máy chủ Naya lưu giữ tất cả các cuộc trò chuyện của bạn ngay cả khi bạn xóa tin nhắn',
  'common.dont.see': 'Không hiện lại thông báo này',
  'field.comment.placeholder': 'Nhập bình luận mới',
  'field.comment.noNoty': 'Tắt thông báo',
  'field.comment': 'Phòng chat',
  'field.comment.title.comment': 'Phòng chat nội bộ',
  'field.comment.title.surComment': 'Phòng chat tổng hợp',
  'field.comment.title.clientComment': 'Phòng chat khách hàng',
  'common.addImage': 'Thêm hình ảnh',
  'field.document.photo': 'Hình ảnh',
  'common.send': 'Chuyển tiếp',
  'common.client': 'Khách hàng',
  'field.comment.noMessage': 'Chưa có tin nhắn.',
  'field.comment.member': 'Thành viên',
  'field.comment.me': 'Tôi',
  'field.comment.placeholder.content': 'Vui lòng nhập nội dung.',
  'field.comment.delete.confirm': 'Bạn có chắc muốn xóa không?',
  'consult.checkList.spaces.uncheck.2': 'Bạn có chắc muốn xóa không?',
  'field.comment.addImage.title': 'Gửi hình ảnh',
  'field.comment.addImage.placeholder': 'Vui lòng thả hình ảnh vào đây\nNếu bạn muốn đính kèm trực tiếp',
  'field.comment.addImage.placeholder.button': 'Vui lòng nhấn vào đây',
  'field.comment.addImage.drag.placeholder': 'Có thể thả file\ntại bất kỳ đâu',
  'field.comment.addImage.attachments': 'Đính kèm hình ảnh',
  'field.comment.empty': 'Chưa có tin nhắn nào.\n{name} hãy bắt đầu cuộc trò chuyện nhé! 👋',

  // field/document
  'title.field.document': 'Tài liệu đính kèm',
  'field.document.name': 'Tên tài liệu',
  'field.document.dateCreated': 'Ngày tạo',
  'common.creator': 'Người tạo',
  'field.workLog.detail.7': 'Người tạo',
  'field.minutesOfMeetings.writer': 'Người tạo',
  'field.contract.writer': 'Người tạo',
  'title.field.document.add': 'Thêm tài liệu đính kèm',
  'title.field.document.update': 'Sửa tài liệu đính kèm',
  'common.update.delete': 'Chỉnh sửa / Xóa',
  'consult.file.attachment': 'Đính kèm file',
  'consult.button.edit': 'Sửa',
  'field.document.add': 'Thêm tài liệu đính kèm mới',
  'field.document.name.and.file': 'Tên file và tài liệu',
  'field.document.detail': 'Chi tiết',
  'field.document.file.count': '{count} file',
  'field.document.file.download': 'Tải xuống file',
  'field.document.add.popup.title': 'Thêm tài liệu đính kèm  ',
  'field.document.name.title': 'Tên tài liệu',
  'field.document.file.title': 'File tài liệu',
  'field.document.name.placeholder': 'Vui lòng nhập tên tài liệu',
  'field.document.update.popup.title': 'Sửa tài liệu đính kèm',
  'field.document.delete.confirm': 'Bạn có chắc muốn xóa không?',
  'field.document.delete.success': 'Đã xóa',
  'field.document.add.success': 'Đã tải lên',
  'field.document.update.success': 'Đã sửa',

  // field/setting
  'basic.info': 'Thông tin cơ bản',
  'field.staff.num': 'Số lượng nhân viên',
  'search.active': 'Tình trạng hoạt động',
  'material.active': 'Tình trạng hoạt động',
  'common.active': 'Tình trạng hoạt động',
  'search.createdAt': 'Ngày đăng ký',
  'order.dateCreated': 'Ngày đăng ký',
  'sellerGroup.dateCreated': 'Ngày đăng ký',
  'field.staff': 'Nhân viên phụ trách',
  'field.staff.update': 'Nhập nhân viên phụ trách',
  'user.name': 'Tên',
  'seller.name': 'Tên',
  'common.name': 'Tên',
  'search.name': 'Tên',
  'common.phone': 'SĐT',
  'search.phone': 'SĐT',
  'seller.address2': 'Địa chỉ',
  'common.address2': 'Địa chỉ',
  'field.date.start.option': 'Ngày khởi công (không bắt buộc)',
  'field.date.end.option': 'Ngày hoàn công (không bắt buộc)',
  'user.active': 'Tình trạng khả dụng',
  'widgets.search': 'Tìm kiếm',
  'button.search': 'Tìm kiếm',
  'widgets.reset': 'Cài đặt lại',
  'button.select': 'Chọn',
  'common.id': 'Tên đăng nhập',
  'staff.fields.num': 'Số lượng công trình phụ trách',
  'seller.dateCreated': 'Ngày tham gia',
  'common.showAddress': 'Xác nhận địa chỉ',
  'error.field.empty': 'Bắt buộc điền các thông tin: tên công trình, địa chỉ, địa chỉ chi tiết, hiện trạng',
  'address.placeholder': 'Nhập địa chỉ',
  'common.yes': 'Đồng ý',
  'common.no': 'Không',
  'button.save': 'Lưu',
  'field.date.start.end': 'Lịch thi công',
  'field.dateCreated': 'Ngày tạo công trình',
  'common.info': 'Thông tin',
  'field.input.staff': 'Nhân viên công trình',
  'field.staff.setting': 'Cài đặt',
  'field.staff.empty': 'Không có nhân viên cho công trình trên.',
  'field.staff.empty.button': 'Tạo nhân viên >',
  'field.basic.info': 'Thông tin công trình',
  'field.basic.info.setting': 'Sửa thông tin công trình',
  'field.staff.update.title': 'Thiết lập nhân viên phụ trách',
  'field.staff.add': 'Tạo mới nhân viên phụ trách',
  'field.staff.update.popup.filter.name': 'Tìm tên nhân viên',
  'field.staff.update.popup.filter.phone': 'Tìm số điện thoại',
  'field.staff.update.popup.header.title': 'Tổng số nhân viên',
  'field.staff.update.popup.button.save': 'Lưu {count} người đã chọn',
  'settings.customer.register.tooltip': 'Khi kết nối khách hàng, báo cáo công trình, phòng chat khách hàng\n và tài liệu đính kèm sẽ được chia sẻ, các tính năng khác sẽ không được chia sẻ.',
  'settings.customer.register.button': 'Đăng ký  ',
  'settings.customer.register.status': 'Trạng thái đăng ký',
  'consult.order.drawing.noty.etc.title': 'Khác',
  'settings.customer.register.empty': 'Không có khách hàng được kết nối.\nKhi kết nối khách hàng, báo cáo công trình, phòng chat và tài liệu đính kèm sẽ được chia sẻ.',
  'settings.customer.register.empty.button': 'Kết nối khách hàng >',
  'message.save': 'Đã lưu',
  'settings.customer.register.search.empty': 'Không có kết quả tìm kiếm. Vui lòng kiểm tra lại ID khách hàng.',
  'settings.customer.register.phone': 'Số điện thoại khách hàng',
  'settings.customer.register.search.guest': "là khách hàng chưa đăng ký.\nSau khi nhấn 'Mời', vui lòng chia sẻ link đến khách hàng!",
  'settings.customer.register.share': 'Chia sẻ',
  'settings.customer.invite.success': 'Đã gửi lời mời đến khách hàng\n',
  'settings.customer.invite.success.suffix': '! 💌',
  'settings.guest.invite.success': 'Đã gửi lời mời tham gia công trình đến SĐT ',
  'settings.guest.invite.success.text.1': "Nhấn 'Chia sẻ' để gửi liên kết tải ứng dụng cho khách hàng,\ngiúp sử dụng dịch vụ một cách tiện lợi hơn.",
  'settings.guest.invite.success.text.2': 'Khi khách hàng đăng ký thành viên,\nKH sẽ nhận được tin nhắn lời mời dưới đây từ ứng dụng.',
  'settings.customer.invite.success.text.1': 'Đã gửi thông báo lời mời đến khách hàng qua ứng dụng',
  'settings.customer.invite.success.text.2': 'Khi khách hàng đăng nhập, khách hàng sẽ\nxem được tin nhắn lời mời dưới đây trong ứng dụng.',
  'settings.guest.copy.text.prefix': '[NAYA] ',
  'settings.guest.copy.text.suffix': ' đã gửi lời mời tham gia công trình\nHãy nhấn vào link dưới đây để nhận báo cáo công trình theo thời gian thực!\n',
  'settings.guest.copy.success': 'Đã sao chép.',

  // setting
  'account.info': 'Thông tin tài khoản',
  'profile.password.change': 'Thay đổi mật khẩu',
  'profile.password.old': 'Nhập mật khẩu cũ',
  'profile.password.new': 'Nhập mật khẩu mới',
  'profile.password.confirmNew': 'Nhập lại mật khẩu mới',
  'profile.password.same': 'Mật khẩu chính xác',
  'profile.password.notSame': 'Mật khẩu không chính xác',
  'profile.password.confirm': 'Xác nhận',
  'button.confirm': 'Xác nhận',
  'profile.password.condition': 'Bao gồm 6 ~ 15 ký tự chữ và số',
  'profile.password.emptyOld': 'Nhập mật khẩu cũ',
  'profile.password.emptyNew': 'Nhập mật khẩu mới',
  'profile.password.not': 'Mật khẩu không chính xác',
  'profile.password.notPattern': 'Xác nhận lại mật khẩu mới',
  'userInfo.email': 'Email Người đại diện',
  'seller.companyName': 'Tên công ty',
  'seller.phone': 'Mã số thuế',
  'seller.businessOwner': 'Tên người đại diện',
  'seller.typeOfBusiness': 'Loại hình kinh doanh',
  'seller.itemsOfBusiness': 'Hạng mục',
  'common.staff': 'Người phụ trách',
  'order.staff': 'Người phụ trách',
  'common.info.refund.transfer': 'Thông tin tài khoản hoàn tiền',
  'sidebar.material.user': 'Tạo/Sửa Nhân viên',
  'staff.info': 'Thông tin nhân viên',
  'staff.birth.option': 'Ngày tháng năm sinh (không bắt buộc)',
  'staff.date.entered.resignation.option': 'Ngày vào làm/Ngày nghỉ việc (không bắt buộc)',
  'seller.memo.option': 'Ghi chú (không bắt buộc)',
  'sidebar.material.user.detail': 'Chi tiết nhân viên',
  'sidebar.material.user.create': 'Tạo nhân viên',
  'sidebar.material.user.modify': 'Sửa nhân viên',
  'staff.date.entered.resignation': 'Ngày vào làm/Ngày nghỉ việc',
  'staff.birth': 'Ngày tháng năm sinh',
  'staff.fields': 'Công trình phụ trách',
  'button.ChangePassword': 'Thay đổi mật khẩu',
  'button.update': 'Cập nhật',
  'partner.name': 'Tên công ty',
  'button.create': 'Tạo',
  'seller.memo': 'Ghi chú',
  'company.info': 'Thông tin nhà thầu',
  'sidebar.material.userInfo': 'Thông tin người dùng',
  'button.searchStaff': 'Tìm kiếm nhân viên',
  'error.password.INVALID_PASSWORD': 'Mật khẩu hiện tại không chính xác',
  'password.change.message': 'Mật khẩu đã thay đổ.\nVui lòng đăng nhập lại',
  'setting.me': 'Trang của tôi',
  'setting.staff': 'Quản lý nhân viên nội bộ',
  'setting.staff.title': 'Quản lý nhân viên nội bộ',
  'profile.password.success': 'Đã thay đổi mật khẩu',
  'error.user.empty': 'Tên, số điện thoại, mật khẩu và quyền hạn là những mục bắt buộc.',
  'error.user.modify.empty': 'Tên, số điện thoại và quyền hạn là những mục bắt buộc.',
  'consult.button.save': 'Lưu   ',
  'setting.staff.permission': 'Quyền hạn',
  'setting.staff.permission.active': 'Hoạt động',
  'setting.staff.permission.inactive': 'Không hoạt động',
  'staff.date.entered': 'Bắt đầu làm việc',
  'staff.date.resignation': 'Đã nghỉ việc',
  'staff.date.working': 'Đang làm việc',
  'staff.memo.empty': 'Không có ghi chú',
  'setting.staff.detail.title': 'Thông tin chi tiết về nhân viên',
  'setting.staff.phone.placeholder': 'Vui lòng nhập SĐT',
  'setting.staff.date.placeholder': 'Chọn ngày',
  'setting.staff.permission.select': 'Chọn quyền hoạt động',
  'setting.staff.date.entered': 'Ngày vào công ty',
  'setting.staff.date.resignation': 'Ngày nghỉ việc',
  'setting.staff.memo.placeholder': 'Vui lòng nhập ghi chú',
  'setting.staff.password.message': 'Khi nhân viên đăng nhập,\ncó thể thay đổi mật khẩu trong mục cài đặt.',
  'setting.staff.create.success': 'Đăng ký nhân viên hoàn thành.',
  'setting.staff.create.success.button': 'Đăng ký hoàn thành',
  'setting.staff.modify': 'Sửa thông tin nhân viên',
  'setting.my.info': 'Thông tin tài khoản',
  'setting.company.info': 'Thông tin công ty',
  'setting.fields.num': '{count} công trình',
  'setting.profile.image.change': 'Thay đổi hình ảnh',
  'setting.profile.image': 'Ảnh đại diện',
  'setting.staff.empty.title': 'Không có nhân viên được đăng ký',
  'setting.staff.empty.button': 'Đăng ký nhân viên nội bộ >',

  // account-book
  'dashboard.field.account.book.add': 'Nhập thu chi công trình',
  'dashboard.field.account.book.sort.latest': 'Mới nhất',
  'field.minutesOfMeetings.date.-dateMeeting': 'Mới nhất',
  'dashboard.field.account.book.sort.oldest': 'Cũ nhất',
  'dashboard.field.account.book.type.all': 'Tất cả',
  'dashboard.field.budget.request': 'Yêu cầu ngân sách',
  'dashboard.field.account.book.category.all': 'Tất cả phân loại',
  'dashboard.field.account.book.no': 'STT',
  'dashboard.field.account.book.date': 'Ngày tạo',
  'dashboard.field.account.book.type': 'Loại',
  'dashboard.field.account.book.category': 'Phân loại',
  'consult.order.drawing.noty.column.type': 'Phân loại',
  'order.history.type': 'Phân loại',
  'order.cancel.item.type': 'Phân loại',
  'order.return.item.type': 'Phân loại',
  'dashboard.field.account.book.description': 'Nội dung',
  'dashboard.field.account.book.description.CATEGORY_SALES': 'Ghi chú khoản tiền',
  'nayaBoard.content': 'Nội dung',
  'recruitment.companyHistories.content': 'Nội dung',
  'dashboard.field.account.book.amount': 'Số tiền',
  'material.refund.amount': 'Số tiền',
  'order.cancel.item.sum': 'Số tiền',
  'order.return.item.sum': 'Số tiền',
  'order.amount': 'Số tiền',
  'field.ammount': 'Số tiền',
  'dashboard.field.amount': 'Số tiền',
  'dashboard.field.account.book.new': 'Tạo thu chi mới',
  'dashboard.field.account.book.date.common': 'Ngày',
  'dashboard.field.account.book.contract.amount': 'Số tiền',
  'dashboard.field.account.book.amount.without.tax': 'Số tiền (chưa VAT)',
  'dashboard.field.account.book.expense.category': 'Phân loại chi phí',
  'dashboard.field.account.book.expense.select': 'Chọn loại chi phí',
  'dashboard.field.account.book.cancel.title': 'Bạn muốn dừng tạo thu chi mới?',
  'dashboard.field.account.book.cancel.content': 'Nội dung đã tạo sẽ không được lưu nếu bạn chọn dừng tạo',
  'dashboard.field.account.book.cancel.button': 'Đồng ý',
  'dashboard.field.account.book.update': 'Sửa thu chi công trình',
  'dashboard.field.account.book.update.cancel': 'Bạn muốn dừng sửa thu chi?',
  'dashboard.field.account.book.update.content': 'Nội dung đã sửa sẽ không được lưu nếu bạn chọn dừng sửa',
  'dashboard.field.account.book.delete': 'Bạn muốn xóa thu chi công trình?',
  'dashboard.field.account.book.delete.content': 'Nội dung đã xóa sẽ không thể khôi phục',
  'dashboard.field.account.book.budget.setting': 'Thiết lập ngân sách chi',
  'dashboard.field.account.book.description.placeholder': 'Vui lòng nhập nội dung',
  'dashboard.field.account.book.description.placeholderCATEGORY_SALES': 'EX: Tiền hợp đồng, tiền phát sinh',
  'dashboard.field.account.book.search.result': 'Kết quả tìm kiếm',
  'dashboard.field.account.book.search.placeholder': 'Tìm kiếm nội dung',
  'dashboard.field.account.book.amount.total': 'Tổng',
  'dashboard.field.account.book.search.empty': 'Không có kết quả tìm kiếm cho ',
  'dashboard.field.account.book.budget.setting.placeholder': 'Nhập số chi phí dự kiến của bạn',
  'dashboard.field.account.book.example': 'Ví dụ',
  'dashboard.field.account.book.onboarding.sumSales': 'Số tiền hợp đồng (Tổng doanh thu)',
  'dashboard.field.account.book.onboarding.sumCollections': 'Tổng khoản thu lũy kế',
  'dashboard.field.account.book.onboarding.sumPurchase': 'Tổng chi phí lũy kế',
  'dashboard.field.account.book.onboarding.skip': 'Bỏ qua',
  'field.contract.placeholder.date': 'Chọn ngày',
  'field.contract.placeholder.price': 'Nhập số tiền',
  'account.book.dummy.1': 'Hợp đồng',
  'account.book.dummy.2': 'Phát sinh',
  'account.book.dummy.3': 'Tiền tạm ứng',
  'account.book.dummy.4': 'Thanh toán giai đoạn 1',
  'account.book.dummy.5': 'Thanh toán giai đoạn 2',
  'account.book.dummy.6': 'Chi phí ăn uống',
  'account.book.dummy.7': 'Thạch cao thường: 9.5T * 900 * 1800',
  'account.book.dummy.8': 'Tiền tạm ứng',
  'dashboard.field.account.book.image': 'Hình ảnh đính kèm',
  'dashboard.field.account.book.receipt': 'Đính kèm hóa đơn',
  'dashboard.field.account.book.image.placeholder': 'Đính kèm hình ảnh',

  // field/sales-note
  'field.salesNote': 'Ghi chú\ncông trình',
  'field.salesNote.add': 'Nhập Ghi chú công trình',
  'field.salesNote.attachments': '{count} file đính kèm',
  'field.salesNote.empty.1': 'Không có ghi chú công trình được nhập',
  'field.salesNote.empty.2': '(Ghi chú công trình sẽ không được chia sẻ với khách hàng)',
  'field.salesNote.empty.button': 'Nhập ghi chú công trình mới',
  'work.file': 'File đính kèm',
  'field.salesNote.add.new': 'Nhập ghi chú công trình mới',
  'field.salesNote.edit': 'Sửa ghi chú công trình',
  'common.photo': 'Hình ảnh',
  'field.salesNote.placeholder': 'Vui lòng nhập thông tin về không gian thi công như diện tích,\ncông tác tạm, không gian trống hay không, phong cách mong muốn ...',
  'common.attachments.file': 'Đính kèm file',
  'common.attachments.file2': 'Đính kèm file',
  'consult.customer.create.dateStart.placeholder': 'Chọn ngày',
  'popup.customer.delete.confirm': 'Xóa',
  'field.salesNote.delete.confirm': 'Bạn thật sự muốn xóa\nghi chú công trình?',
  'field.salesNote.delete.success': 'Đã xóa',
  'field.salesNote.cancel.edit': 'Bạn có muốn hủy nội dung chỉnh sửa?',
  'field.salesNote.new': 'Tạo mới',
  'consult.customer.files': 'Tài liệu đính kèm',
  // only korean
  'field.salesNote.oldData': '고객카드',

  // settings/customer
  'settings.customer.register': 'Đăng ký khách hàng',
  'settings.customer.register.new': 'Đăng ký khách hàng mới',
  'settings.customer.register.new.input': 'Đăng ký khách hàng mới',
  'settings.customer.register.new.input.placeholder': 'customer@gmail.com',
  'settings.customer.register.new.input.description': '* Báo cáo công trình, phòng chat, tài liệu đính kèm sẽ được chia sẻ',
  'settings.customer.register.new.button': 'Mời',
  'settings.customer.register.new.invite.success': 'Đã gửi lời mời đến khách hàng {name}',
  'settings.customer.register.new.invite.success.button': 'Đã kết nối',
  'settings.customer.register.new.invite.success.button.waiting': 'Đang chờ chấp nhận',
  'settings.customer.register.new.invite.success.button.reinvite': 'Mời lại',
  'settings.customer.register.new.invite.success.button.reinvite.success': 'Đã gửi lại lời mời đến khách hàng {name}',
  'common.status': 'Tình trạng',
  'common.waiting.accept': 'Đang chờ chấp nhận',
  'common.connected': 'Đã kết nối',
  'err.invited.customer': 'Khách hàng đã được mời',
  'err.recruitment.email.2': 'Vui lòng nhập địa chỉ email',

  // private note
  'private.note': 'Ghi chú cá nhân',
  'private.note.keyword.placeholder': 'Tìm kiếm theo tiêu đề hoặc nội dung',
  'private.note.create.body.placeholder': 'Để lại ghi chú cá nhân bạn muốn lưu giữ.\nGhi chú này sẽ không được chia sẻ cho người khác.',
  'private.note.search.result': 'Không có ghi chú nào phù hợp với ',
  'private.note.empty': 'Không tìm thấy ghi chú bạn cần?',
  'private.note.empty.button': 'Tạo mới >',
  'private.note.empty.title': 'Không có tiêu đề',
  'private.note.empty.body': 'Không có nội dung',
  'private.note.empty.attachment': 'Không có file đính kèm',
  'private.note.create.cancel.title': 'Bạn muốn hủy soạn ghi chú?',
  'private.note.create.cancel.sub': 'Nếu hủy, nội dung đã nhập\nsẽ không được lưu',
  'private.note.delete.title': 'Hủy ghi chú này?',
  'private.note.delete.sub': 'Nếu xóa, sẽ không thể khôi phục lại.\nBạn có chắc chắn muốn xóa không?',
  'private.note.modify.success': 'Đã lưu',

  // ! 베트남 사용구분 =========================================================================================

  // consult
  'consult.title.search': '고객검색',
  'consult.title.create': '신규상담',
  'consult.input.search.placeholder': '고객명, 휴대전화번호, 주소 등 검색',
  'consult.customer.search.result': '명이 검색되었습니다.',
  'consult.button.create.customer': '신규 상담',
  'consult.button.layout.type.dashboard': '대시보드형',
  'consult.button.layout.type.list': '리스트형',
  'consult.button.prev': '이전',
  'consult.button.next': '다음',
  'consult.button.order.drawing': '신청하기',
  'consult.button.addSpace': '+ 공간 추가하기',
  'consult.customer.files2': '추가 파일',
  'consult.customer.files.button': '+ 파일 첨부\n클릭 혹은 이곳에 드롭하세요',
  'consult.customer.work.files.button': '+ 사진 첨부하기',
  'consult.customer.files.info': '* 첨부 파일은 pdf, png, jpg만 가능합니다',
  'consult.title.customer': '고객상담',
  'consult.title.extra': '추가정보',
  'consult.title.info.modify': '고객기본정보',
  'consult.title.checkList': '상담정보',
  'consult.title.designDownload': '디자인 다운로드',
  'consult.customer.add': '+ 신규 상담 등록',
  'consult.customer.empty': '등록한 고객이 없습니다',
  'consult.customer.searchWord': '최근 검색어',
  'consult.customer.searchWord.noData': '최근 검색한 고객이 없습니다',
  'consult.customer.info.name': '고객명(발주처명)',
  'consult.customer.info.basic': '고객기본정보',
  'consult.customer.info.genderAndAgeRange': '성별/나이대',
  'consult.customer.info.dateCreated': '상담일자',
  'consult.customer.info.status': '상담상태',
  'consult.customer.create.name': '고객명(발주처명)',
  'consult.customer.create.name.placeholder': '고객님의 성함 또는 회사명을 입력해주세요',
  'consult.customer.create.address': '현장주소',
  'consult.customer.create.address.placeholder': '주소지를 입력해주세요',
  'consult.customer.create.dateStart': '공사 시작(예정)일',
  'consult.customer.create.phone.placeholder': '(-)빼고 숫자만 입력해주세요',
  'consult.customer.create.email': '이메일(선택)',
  'consult.customer.create.email.placeholder': '고객님의 이메일을 입력해주세요',
  'consult.customer.create.fieldName': '현장명(선택)',
  'consult.customer.create.policyAgree': '개인정보 활용 동의(필수)',
  'consult.customer.create.button.confirm': '입력 완료',
  'consult.customer.create.button.edit': '수정 완료',
  'consult.customer.create.error.name': '고객명을 입력해주세요',
  'consult.customer.create.error.fieldType': '현장유형을 선택해주세요',
  'consult.customer.create.error.residentialType': '주거공간 유형을 선택해주세요',
  'consult.customer.create.error.address': '주소를 입력해주세요',
  'consult.customer.create.error.latLong': '주소에 오류가 있습니다\n다른 주소를 선택해주세요',
  'consult.customer.create.error.dateStart': '공사 시작(예정)일을 입력해주세요',
  'consult.customer.create.error.phone': '휴대전화번호를 입력해주세요',
  'consult.customer.create.error.gender': '성별을 선택해주세요',
  'consult.customer.create.error.age': '고객 연령대를 선택해주세요',
  'consult.customer.info.customerConsult.title': '상담하기',
  'consult.customer.info.customerConsult.title2': '고객 상담 시 함께 작성하세요',
  'consult.customer.info.detailInfo.title': '시공사전용',
  'consult.customer.info.detailInfo.title2': '디자인/견적 시 필요한 정보를 작성해요',
  'consult.customer.info.proposal.title': '디자인 제안서',
  'consult.customer.info.proposal.title2': '의뢰하기 >',
  'consult.customer.info.drawing.title': '3D 투시도',
  'consult.customer.info.drawing.title2': '의뢰하기 >',
  'consult.customer.info.designDownload.title': '디자인 다운로드',
  'consult.customer.info.designDownload.title2': '의뢰한 디자인 제안서와 3D투시도를\n다운로드 받아요',
  'consult.customer.info.label.dateStart': '시공 예정일',
  'consult.customer.info.label.consultLog': '상담일자',
  'consult.customer.consult.title': '상담내역',
  'consult.customer.consult.title2': '작성한 내역을 확인해보세요',
  'consult.customer.consult.basicInfo': '현장 정보',
  'consult.customer.consult.basicInfo.demolitions': '철거',
  'consult.customer.consult.basicInfo.temporaryWorks': '가설',
  'consult.customer.consult.basicInfo.spaceSizes': '평형',
  'consult.customer.consult.basicInfo.spaces': '시공 공간',
  'consult.customer.consult.basicInfo.spaceSituations': '공간 상황',
  'consult.customer.consult.basicInfo.styles': '스타일',
  'consult.customer.consult.workInfo.commercial': '미팅 내역',
  'consult.customer.consult.workInfo.commercial.detail.title': '상담 내용',
  'consult.customer.consult.basicInfo.null': ' 선택하기',
  'consult.customer.consult.spaces.material.null': '자재 선택하기',
  'consult.customer.consult.spaces.material.commercial': '자세한 상담 내용을 메모해주세요',
  'consult.customer.edit.success.title': '수정이 완료되었습니다.',
  'consult.customer.detailInfo.budgets': '추정 평당 예산(중복 선택 가능, 필수)',
  'consult.customer.detailInfo.memo.label': '기타(메모, 필수)',
  'consult.customer.detailInfo.memo.placeholder':
    '고객님과 잘 상담하셨나요?\n디자인 또는 견적 요청 관련하여 참고할 사항을 나야에게 알려주세요.\n상담때 사용한 평면도 이미지와 고객 특성을 입력해주세요.\n\nEX. 디자인에 매우 관심이 높음',
  'consult.checkList.title.residential.demolitions': '시공 전, 철거가 필요한 부분을 선택해주세요',
  'consult.checkList.title.residential.temporaryWorks': '필요한 가설을 선택해주세요',
  'consult.checkList.title.residential.spaceSizes': '공간 평형을 선택해주세요(전용면적 기준)',
  'consult.checkList.title.residential.spaces': '공사 할 공간을 모두 선택해주세요',
  'consult.checkList.title.residential.spaces.all': '전체 공간 선택',
  'consult.checkList.title.residential.spaceSituations': '공간의 상황을 선택해주세요',
  'consult.checkList.title.residential.styles': '원하는 스타일을 골라주세요\n중복선택 가능합니다',
  'consult.checkList.title.material.yesOrNo': '시공하시나요?',
  'consult.checkList.title.commercial.demolitions': '시공 전, 철거가 필요한 부분을 선택해주세요',
  'consult.checkList.title.commercial.temporaryWorks': '필요한 가설을 선택해주세요',
  'consult.checkList.title.commercial.spaceSizes': '공간 평형을 선택해주세요(전용면적 기준)',
  'consult.checkList.title.commercial.spaces': '시공 할 공간을 선택해주세요',
  'consult.checkList.title.commercial.spaceSituations': '공간의 상황을 선택해주세요',
  'consult.checkList.work.text.label': '기타(메모)',
  'consult.checkList.work.text.placeholder': '특별히 원하시는 컬러, 가격대, 브랜드가 있을 경우 메모해주세요\n(이미지가 있으면 아래 첨부해주세요)',
  'consult.order.proposal.title': '제안서에 들어갈 3D투시도\n공간을 선택해주세요',
  'consult.order.drawing.title': '3D투시도로 만들고싶은\n공간을 선택해주세요',
  'consult.order.proposal.subtitle1': '2컷까지 무료 (',
  'consult.order.proposal.subtitle2': '/2)',
  'consult.order.drawing.subtitle': '* 디자인필요\n* 같은 공간에 뷰가 2개 이상 추가되는 경우 요청 사항에 적어주세요.',
  'consult.order.space.custom': '기타(직접입력)',
  'consult.order.space.nickName': '어떤 용도의 공간인가요',
  'consult.order.space.add.title': '공간 추가하기',
  'consult.order.drawing.label': '도면(필수)',
  'consult.order.drawing.memo': '요청사항',
  'material.delivery.memo': '요청사항',
  'consult.order.commercial.drawing.memo.placeholder': '요청사항이 있다면 여기에 적어주세요',
  'consult.order.drawing.price.title': '결제 예정 금액',
  'consult.order.drawing.price.label': '기본 상품',
  'consult.order.proposal.price.additional.label': '추가 상품',
  'consult.order.proposal.price.member': '회원가',
  'consult.order.proposal.price.nonMember': '비회원가',
  'consult.order.proposal.price.included': '무료',
  'consult.order.proposal.priceSum.label': '최종 결제금액',
  'consult.order.drawing.noty.title': '안내 및 동의',
  'consult.order.drawing.noty.residential.content.title': '본인은 안내된 (주)씨투와이 NAYA(나야)의 업무 규정에 따라\n디자인을 제공받기로 하며 다음 사항에 동의합니다.',
  'consult.order.drawing.noty.period.title': '1. 제작 일정',
  'consult.order.drawing.noty.column.type.drawing': '3D투시도',
  'consult.order.drawing.noty.column.type.drawing.suffix': '(컷 당)',
  'consult.order.drawing.noty.column.type.proposal': '디자인 제안서',
  'consult.order.drawing.noty.column.period': '소요기간',
  'consult.order.drawing.noty.column.period.drawing': '2~4일(영업일 기준)',
  'consult.order.drawing.noty.column.period.proposal': '5~7일(영업일 기준)',
  'consult.order.drawing.noty.price.title': '2. 디자인 제작비',
  'consult.order.drawing.noty.column.price.nonMember': '정상가',
  'consult.order.drawing.noty.column.price.nonMember.drawing': '18만원',
  'consult.order.drawing.noty.column.price.nonMember.proposal': '80만원',
  'consult.order.drawing.noty.column.price.member': '회원가',
  'consult.order.drawing.noty.column.price.member.drawing': '9만원',
  'consult.order.drawing.noty.column.price.member.proposal': '35만원',
  'consult.order.drawing.noty.price.sum': '총 제작비',
  'consult.order.drawing.noty.price.payment': '선급 결제',
  'consult.order.drawing.noty.price.remains': '잔금',
  'consult.order.drawing.noty.price.payback': '무료조건',
  'consult.order.drawing.noty.price.memo': '최종결제금액',
  'consult.order.drawing.noty.column.etc': '비고',
  'consult.order.drawing.noty.column.etc.label': '면적이 넓거나\n상업시설인 경우\n추가비용 발생가능',
  'consult.order.drawing.noty.etc.label': '1) 투시도 및 제안서 일부 수정은 2회까지 무료 / 이후 회원가 적용됩니다\n2) 제작 및 납품되는 모든 디자인 저작권은 나야(NAYA)에게 있습니다',
  'consult.order.drawing.noty.right.title': '3. 디자인 저작권',
  'consult.order.drawing.noty.right.label': '디자인의 저작권은 NAYA(나야)에 귀속되며, “의뢰한 현장 시공" 이외 목적으로\n사용할 수 없습니다. 이를 위반 시 그에대한 손해를 배상하기로 합니다.',
  'consult.order.drawing.agree': '[필수] 위 내용 모두 숙지하였으며, 모두 동의합니다',
  'consult.order.drawing.agree.popup.title': '내용을 충분히 이해하셨나요?',
  'consult.order.drawing.agree.popup.content': '설명 내용을 제대로 이해하지 못했는데도\n이해했다고 확인하는 경우, 추후 해당 내용과\n관련한 권리구제가 어려울 수 있어요',
  'consult.order.drawing.agree.popup.button': '네, 충분히 이해했어요',
  'consult.design.request': '의뢰',
  'consult.design.download.title': '디자인 다운로드',
  'consult.design.download.info': '*디자인 원본파일은 ',
  'consult.design.download.info2': 'CRM>고객상담>디자인 주문상세내역',
  'consult.design.download.info3': '에서 결제 후 다운로드를 할 수 있습니다',
  'consult.design.payment.request': '결제하고 디자인을 확인해보세요',
  'consult.design.payment.request.button': '결제하기',
  'consult.design.order.label': '주문 상품',
  'consult.design.order.price.sum': '주문 금액',
  'consult.design.info.title': '기본 의뢰정보',
  'consult.design.info.status': '주문상태',
  'consult.design.info.product': '주문상품',
  'consult.design.info.dateCreated': '주문일시',
  'consult.design.info.dateWorking': '작업일시',
  'consult.design.payment.price': '결제 금액',
  'consult.design.payment.datePaid': '결제 일시',
  'consult.design.payment.method': '결제 방법',
  'payment.method': '결제 방법',
  'consult.design.payment.amount': '주문 금액',
  'consult.design.payment.amountVAT': '부가세',
  'consult.design.payment.amountSum': '총 결제 금액',
  'consult.design.chat.title': '요청 사항',
  'consult.payment.title': '결제',
  'consult.payment.select.title': '결제 수단을 선택해주세요',
  'consult.payment.virtual.title': '무통장입금 결제하기',
  'consult.payment.method.VIRTUAL_ACCOUNT': '무통장입금',
  'consult.payment.method.CARD': '카드 결제',
  'consult.payment.virtual.customerName': '입금자명*',
  'consult.payment.virtual.customerName.placeholder': '입금자명을 입력해주세요',
  'consult.payment.virtual.bank': '입금계좌 은행*',
  'consult.payment.virtual.bank.placeholder': '은행 선택',
  'consult.payment.virtual.email': '이메일',
  'common.email': '이메일',
  'consult.payment.virtual.email.placeholder': '결제 정보 받을 이메일을 입력해주세요',
  'consult.payment.virtual.registrationNumber': '사업자번호(지출증빙용)',
  'consult.payment.virtual.registrationNumber.placeholder': '(-)없이 사업자번호를 입력해주세요',
  'consult.payment.virtual.confirm': '가상계좌 발급하기',
  'consult.payment.virtual.paidInfo.title': '가상계좌 발급',
  'consult.payment.virtual.paidInfo.title2': '가상계좌정보',
  'consult.payment.virtual.paidInfo.bank': '은행명',
  'consult.payment.virtual.paidInfo.accountNumber': '계좌번호',
  'consult.payment.virtual.paidInfo.price': '입금금액',
  'consult.payment.virtual.paidInfo.dueDate': '입금기한',
  'consult.constructStatus.DEFAULT': '상태',
  'order.history.status': '상태',
  'consult.staff': '직원',
  'buyer.staff': '직원',
  'consult.sort.dateCreated': '최근 등록순',
  'consult.sort.dateUpdated': '최근 업데이트순',
  'consult.sort.dateLastConsult': '최근 상담순',
  'consult.checkList.title.residential.livingRoom.same': '거실과 동일한 자재 선택하기',
  'consult.chatView.placeholder': '메시지를 입력하세요',
  'consult.checkList.spaces.uncheck': '공간 선택 해제 시\n작성한 내용이 모두 삭제됩니다',
  'consult.checkList.commercial.spaces.uncheck': '해당 양식을 제외시\n작성한 내용이 모두 삭제됩니다',
  'consult.customerAccount': '고객계정',
  'consult.history': '미팅 내역',
  'consult.floorHeight.placeholder': '층고 높이 입력',
  'consult.area.placeholder': '평수 입력',
  'consult.area.unit.1': '평당',
  'consult.area.unit.2': '㎡',
  'consult.budget.placeholder': '예산을 작성해주세요',
  'consult.contents.delete': '제외',
  'consult.input.space.placeholder': '공간을 입력해주세요',
  'consult.commercial.contents': '상담내용',
  'consult.commercial.add.history': '+ 미팅 추가하기',
  'consult.change.order': '순서변경',
  'consult.change.order.clicked': '저장하기',
  'consult.verifications.emailRequired': '고객 이메일을 먼저 작성해주세요.',
  'consult.verifications.willSendMail': '고객에게 초대 메일을 보낼까요?',
  'consult.verifications.send': '이메일 보내기',
  'consult.verifications.sendComplete.title': '초대 메일을 보냈습니다.',
  'consult.verifications.sendComplete.content': '고객이 가입을 완료하면 알림을 보내드릴께요:)',
  'consult.verifications.joinCompleted': '고객이 회원가입을 완료하였습니다.',
  'consult.verifications.joinRequest': '고객에게 초대 메일을 이미 보냈습니다.',
  'consult.customer.consult.basicInfo.windowSashs': '창호',
  'consult.checkList.title.residential.windowSashs': '창호 시공을 선택해주세요',
  'step.consult.windowSashs': '창호 시공',
  'consult.design.download.text.REQUEST': '디자인팀에서 접수를 확인하고 있습니다.\n디자인 작업 시 질의 사항이 생긴 경우,\n고객님께 채팅을 통해 질문을 드릴 수 있어요.',
  'consult.design.download.text.WAITING_PAYMENT': '결제 확인이 완료되면 디자인팀에서 작업을 시작합니다.',
  'consult.design.download.text.WORKING_RESIDENTIAL': '작업 소요 기간은 영업일 기준 2~3일 소요됩니다.\n작업이 완료되면 앱 알림을 통해 알려드릴게요.',
  'consult.design.download.text.WORKING_COMMERCIAL': '작업 소요 기간은 별도로 문의해주세요.\n작업이 완료되면 앱 알림을 통해 알려드릴게요.',
  'sidebar.consult.customer': '상담노트',
  'popup.customer.create.success.title': '신규 고객 등록이 완료되었습니다\n바로 상담하시겠어요?',
  'popup.customer.delete.title': '고객정보를 삭제하겠습니까?\n삭제 시 복구가 불가능합니다',
  'popup.customer.detail.startConsult': '아직 상담한 내역이 없습니다.\n바로 상담하시겠어요?',
  'popup.customer.detailInfo.noty.title': '시공사 전용 페이지입니다',
  'popup.customer.detailInfo.noty.content': '고객님과 상담 후에 따로 작성해주세요',
  'popup.customer.request.complete': '의뢰 신청이 완료되었습니다',
  'popup.customer.checkList.complete.title': '의뢰 신청이 완료되었습니다',
  'popup.customer.checkList.complete.content': '고객님과 상담 잘 마치셨나요?\n작성한 정보를 한번 더 확인해보세요',
  'popup.customer.proposal.alert': '시공사전용 정보 입력 후\n디자인 의뢰가 가능합니다',
  'popup.customer.proposal.alert2': '상담정보 입력 후\n디자인 의뢰가 가능합니다',
  'popup.button.checkList.complete': '고객 카드로 이동',
  'popup.button.style.cancel': '다른 스타일 고르기',
  'step.order.drawing.select.space': '투시도 공간 선택',
  'step.order.drawing.confirm': '의뢰서 확인',
  'step.noty.drawing.title': '의뢰 시 주의사항',
  'step.noty.drawing.content': '같은 공간이더라도, 컷 수에\n따라 금액이 추가됩니다',
  'popup.noty.proposal.title': '디자인 제안서 예시',
  'step.noty.proposal.title': '디자인 제안서 구성',
  'step.noty.proposal.content': `• 공간 컨셉\n• 평면도\n• 3D 투시도 2컷\n• 마감재 리스트\n• 가구 및 위생기기 리스트`,
  'step.noty.button': '나야 디자인 사례보기 >',
  'step.consult.demolitions': '철거 여부',
  'step.consult.temporaryWorks': '가설 선택',
  'step.consult.spaceSizes': '평형 선택',
  'step.consult.spaces': '시공 공간',
  'step.consult.spaceSituations': '공간 상황',
  'step.consult.styles': '스타일',
  'step.consult.material': '자재 선택',
  'work.accountancy.drawing': '도면',
  'common.yes2': '네',
  'portfolio.preview': '미리보기',
  'common.preview': '미리보기',
  'popup.customer.create.address.error': '검색 결과가 없습니다.',
  'popup.customer.create.address.oldValue': '지',
  'popup.customer.create.address.oldValue2': '번',
  'popup.customer.create.address.newValue': '도로명',
  'popup.customer.detailInfo.noty.confirm': '네, 알고있습니다',
  'popup.payment.virtual.alert': '가상계좌 발급시 해당 건은 카드 결제가 불가능합니다\n가상계좌를 발급하시겠습니까?',
  'popup.payment.virtual.alert.yes': '발급하기',
  'popup.payment.virtual.button.copy': '계좌 복사',
  'popup.button.style.select': '선택하기',
  'fileUpload.labelFileProcessing': '업로드 중',
  'fileUpload.labelFileProcessingComplete': '업로드 완료',
  'fileUpload.labelTapToUndo': ' ',
  'fileUpload.labelMaxFileSizeExceeded': '파일 크기가 최대 용량을 초과합니다.',
  'fileUpload.labelMaxFileSize': '최대 용량은 {filesize} 입니다.',
  'fileUpload.labelFileTypeNotAllowed': '허용되지 않는 파일형식 입니다.',
  'fileUpload.fileValidateTypeLabelExpectedTypes': '허용되는 파일형식: {allTypes}',
  'fileUpload.mapType.image/*': '이미지',
  'common.error': '서버 통신에 실패했습니다.\n잠시 후 다시 시도해주세요',
  'common.addFile': '파일 추가',
  'common.file': '파일',
  'naya.designTeam': '나야 디자인/코디팀',
  'consult.customer.files.info2': '* 상담에 필요한 현장 사진이나 실측 도면을 넣어서 보관하세요\n',
  'select.all': '전체 선택',
  'common.empty.select': '미입력',
  'common.empty.text': '미작성',
  'common.empty.text.long': '작성된 내용이 없습니다',
  'consult.budget.prefix': '금',
  'consult.budget.suffix': '원정',
  'common.about': '약',
  'consult.add.title': '하루에 1개의 미팅내역을\n생성할 수 있습니다',
  'consult.add.content': '오늘 작성한 미팅을 진행해주세요',
  'consult.first.meeting': '1차 미팅내역',
  'consult.nth.meeting': '차 미팅내역',
  'consult.space.delete.title': '작성된 내용이 모두 삭제됩니다',
  'consult.commercial.save.title': '상담 내역 저장 완료',
  'consult.commercial.save.contents': '24시간 이내로 수정이 가능합니다.',
  'consult.order.commercial.drawing.noty.column.period': '공간 면적에 따라 추가비용 발생하여, 자세한 견적은\n신청 후 나야 디자인팀이 상담을 통해 알려드립니다',
  'consult.order.commercial.drawing.commercial.price': '견적 산출 중입니다',
  'field.go.consult': '상담노트',
  'consult.drawing.button.label': '+ 평면도 첨부하기',
  'consult.drawing.title.label': '디자인 의뢰서',
  'consult.drawing.title': '평면도 첨부하기',
  'consult.drawing.question.title': '그리기 예시 보기',
  'consult.drawing.question.text': '위 그림과 같이 원하는 레이아웃을 직접 그려주시면,\n더 빠르게 3D투시도를 받을 수 있습니다.',
  'consult.drawing.button.changeFile': '파일 변경',
  'consult.drawing.empty.text': '사이즈가 기재된 도면 이미지를 첨부해주세요\npng, jpg 첨부 가능',
  'consult.drawing.empty.button.text': '파일 가져오기',
  'consult.drawing.view.title': '뷰 그리기',
  'consult.drawing.view.pen': '펜',
  'consult.drawing.view.line': '선',
  'consult.drawing.furniture.title': '가구 그리기',
  'consult.drawing.furniture.circle': '원',
  'consult.drawing.furniture.rectangle': '네모',
  'consult.drawing.furniture.text': '텍스트',
  'consult.drawing.furniture.delete': '선택 삭제',
  'consult.drawing.furniture.text.guide': '텍스트를 입력해주세요',
  'consult.drawing.update.title': '평면도 수정하기',
  'consult.customer.consult.checkList.required': '수주지원컨설팅 신청 시 필수 항목',
  'consult.title.2': '상담 정보',
  'consult.order.commercial.drawing.noty.title': '안내',
  'consult.order.commercial.drawing.noty.content': '아래 계좌로 이체를 진행해주세요.',

  // order
  'sidebar.order': '자재주문',
  'order.message': '배송정보를 먼저 입력하면\n해당 자재 주문 내역이 보입니다',
  'order.message.1': '* 표시된 항목은 필수사항입니다',
  'order.select.address': '배송지(현장) 선택',
  'order.field.address': '배송지 주소',
  'order.field.new': '+ 새로운 배송지(현장)로 주문',
  'order.field.new.input': '새로운 배송지 입력',
  'common.dateLastOrder': '최근 주문일',
  'user.phoneNumber': '전화번호',
  'material.unit': '단위',
  'seller.material.unit': '단위',
  'common.unit': '단위',
  'common.amount': '수량',
  'payment.material.quantity': '수량',
  'material.refund.orders.quantity': '수량',
  'order.cancel.item.quantity': '수량',
  'order.return.item.quantity': '수량',
  'order.quantity': '수량',
  'material.priceSale': '판매단가',
  'common.number': '번호',
  'common.hour': '시',
  'common.minute': '분',
  'order.field.budget': '현장 투입 예정 자재',
  'order.add.other.material': '직접 자재 찾기',
  'order.add.material.message': '자재 이름을 검색하세요.',
  'order.category1': '자재 공종',
  'order.category2': '자재 상세 공종',
  'empty.data': '데이터가 없습니다.',
  'order.add.checkList.required': '필수 체크사항',
  'order.add.quantity.placeholder': '수량을 입력해주세요.',
  'order.add.isb2b.message': '상품 이미지 준비중입니다.\n상담하기로 문의해주세요.\n\nTel. 1644-4908',
  'order.add.button': '자재 추가하기',
  'order.add.checkList.required.message': '필수 체크사항을 입력해주세요.',
  'order.add.search.result': '검색 결과',
  'order.add.checkList.modify': '필수 체크사항 수정',
  'order.add.memo': '주문 요청사항',
  'order.add.memo.message': '예) 절단해주세요. 양중팀 연결해주세요.\n차량 높이 제한 / 1.4톤 이하로 해주세요',
  'order.add.address.placeholder': '배송지(현장)를 선택해주세요.',
  'order.add.name.placeholder': '인수자 성명을 입력해주세요.',
  'order.add.phone.placeholder': '전화번호를 입력해주세요.',
  'order.add.button.select': '담기',
  'order.add.button.selected': '담기 완료',
  'order.add.button.add': '발주 요청',
  'order.add.total.1.1': '총 ',
  'order.add.total.1.2': ' 개의 자재 발주',
  'order.add.total.2.1': '주문 합계 : ',
  'order.add.total.2.2': ' (VAT 별도)',
  'order.add.total.3.1': '결제 금액 : ',
  'order.add.total.3.2': ' (VAT 포함)',
  'order.add.total.4': '배송비는 납품처에서 발주서 확인후 입력됩니다.',
  ORDER_ERROR_ADDRESS: '주소를 입력해주세요.',
  ORDER_ERROR_ADDRESS2: '상세 주소를 입력해주세요.',
  ORDER_ERROR_LATITUDE: '주소에 오류가 있습니다.\n주소 검색을 다시 진행해주세요.',
  ORDER_ERROR_LONGITUDE: '주소에 오류가 있습니다.\n주소 검색을 다시 진행해주세요.',
  ORDER_ERROR_RECIPIENTS: '인수자 정보를 확인해주세요.',
  ORDER_ERROR_DATE_REQUIRED_DELIVERY: '희망 도착 일시를 확인해주세요.',
  ORDER_ERROR_ORDER: '발주 요청된 자재가 없습니다.\n자재 수량을 확인해주세요.',
  POPUP_ORDER_MESSAGE: '판매자가 발주서를 검토 중이며, 재고 및 배송비가 확인되면 결제 알림을 앱으로 보내드립니다.',
  POPUP_ORDER_TITLE: '발주 요청 완료',
  'order.add.material.info': '자재 정보',
  'order.category.filter': '카테고리 필터',
  'order.autoCart': '특가마감재',
  'material.option.origin': '원산지',
  'material.option.thickness': '두께',
  'material.option.standard': '규격',
  'material.option.type': '타입',
  'material.option.pcsBox': 'PCS/BOX',
  'material.option.m2Box': 'M2/BOX',
  'material.option.luminosity': '광도',
  'material.option.applicationArea': '적용부위',
  'material.option.brand': '브랜드명',
  'material.option.information': '종합설명',
  'material.option.color': '색상',
  'material.option.modelNumber': '모델품번',
  'material.option.flameRetardant': '방염여부',
  'material.option.certification': '인증서 유무',
  'material.option.part': '부속폼 정보',
  'material.option.rawMaterial': '소재',
  'order.budget.over.message': '예산 초과된 {num}개 상품이 있어요',
  'order.budget.over.message.2': '관리자에게 해당 자재 예산 추가요청할까요?',
  'button.request': '요청하기',
  'order.budget.request.title': '예산 추가 요청',
  'order.budget.request.quantity': '요청 수량',
  'order.budget.request.memo': '추가 사유',
  'order.budget.request.memo.placeholder': '추가 사유를 입력하세요',
  'order.budget.request.confirm': '예산 추가 요청 완료',
  'order.budget.request.confirm.content': '관리자에게 요청 알림이 발송되었습니다\n예산 수정 후에 발주가 가능합니다',
  'order.budget.quantity': '예산수량',

  // field/log-detail
  'partner.update': '변경',
  'title.field.workLog': '공사일보',
  'field.log.detail': '공사일보',
  'field.title.log.detail': '공사일보',
  'dashboard.field.log': '공사일보',
  'field.workLog.detail.1': '결재/확인',
  'field.workLog.detail.3': '작성일자',
  'field.minutesOfMeetings.date.writing': '작성일자',
  'field.workLog.detail.4': '날씨',
  'field.workLog.detail.5': '공구명',
  'field.workLog.detail.6': '공사기간',
  'field.workLog.detail.8': '금일 주요 작업',
  'field.workLog.detail.9': '내일 주요 예정 작업',
  'field.workLog.detail.10': '공사 내용 및 진행률',
  'field.workLog.detail.11': '인원 투입 현황',
  'field.workLog.detail.12': '공종',
  'field.workLog.detail.13': '계약 대비\n비율(보할)',
  'field.workLog.detail.14': '직전누계\n진행비율',
  'field.workLog.detail.15': '금일\n진행비율',
  'field.workLog.detail.16': '공사누계\n진행률',
  'field.workLog.detail.17': '직종',
  'field.workLog.detail.18': '주간',
  'field.workLog.detail.19': '야간',
  'field.workLog.detail.20': '직전 누계',
  'field.workLog.detail.21': '금일',
  'field.workLog.detail.22': '총누계',
  'field.workLog.detail.23': '장비 투입 현황',
  'field.workLog.detail.24': '단위(규격)',
  'field.workLog.detail.25': '직전 누계',
  'field.workLog.detail.26': '금일 수량',
  'field.workLog.detail.27': '총 누계',
  'field.workLog.detail.28': '주요 자재 투입 현황',
  'field.workLog.detail.29': 'Note',
  'field.workLog.detail.30': '진행률 합계',
  'field.workLog.detail.31': '공유하기 (작업일보/사진)',
  'field.workLog.detail.33': '작업내용 저장하기',
  'field.workLog.detail.34': '나야에서 불러오기',
  'field.workLog.detail.34.messages':
    '자재 목록은 해당 현장 내에서 주문한 건 중 배송 중이거나 배송 완료된 건만 조회됩니다.\n다른 일자에서 사용한 주문 건은 다시 선택할 수 없습니다.(현장 일보에 한번만 등록가능)',
  'field.workLog.detail.workLogDetailWV.update': '보할 변경',
  'field.workLog.detail.filter.date': '일자 검색',
  'field.workLog.detail.35': '담당(작성자)',
  'common.download': '다운로드',
  'button.updatable.true': '수정 가능',
  'button.updatable.false': '수정 불가',
  'button.updatable': '수정 불가 처리',
  'message.workLog.confirm': '수정불가 처리시 본 작성일자 포함 이전 일보들은 추가, 수정, 삭제 할 수 없습니다. 수정불가 처리하시겠습니까?',
  'error.worklogDetail.empty': '작성일자, 날씨, 공구명, 금일 주요 작업, 내일 주요 예정 작업은 필수 항목입니다.',
  'error.INVALID_DATE': '수정불가처리 이전 날짜는 선택할 수 없습니다.',
  'common.download.image': '이미지 다운로드',
  'common.download.pdf': 'PDF 다운로드',

  // field/minutes-of-meetings
  'popup.confirm': '완료하시겠습니까?',
  'order.material.etc': '외',
  'unit.countNumber': '개',
  'field.title.minutesOfMeetings': '회의록',
  'field.minutesOfMeetings.new': '+ 새 회의록 작성하기',
  'common.document': '문서',
  'common.people.number': '인',
  'field.minutesOfMeetings.title': '회의제목',
  'field.minutesOfMeetings.participant': '참석자',
  'field.minutesOfMeetings.date': '회의일자',
  'field.minutesOfMeetings.date.dateMeeting': '날짜순',
  'field.minutesOfMeetings.theme': '회의주제',
  'field.minutesOfMeetings.title.create': '새 회의록',
  'common.write.confirm': '작성완료',
  'contents.title': '제목',
  'common.write.placeholder': '제목을 입력해주세요',
  'field.minutesOfMeetings.desc': '회의주제(선택)',
  'field.minutesOfMeetings.desc.placeholder': '회의 주제를 입력해주세요',
  'memo.placeholder': '메모하고 싶은 내용을 자유롭게 적어보세요',
  'field.minutesOfMeetings.participants.placeholders': '회의 참석자 선택하기',
  'common.input.custom': '직접입력',
  'field.minutesOfMeetings.title.update': '회의록 수정',
  'field.minutesOfMeetings.list.empty1': '작성된 회의록이 없습니다',
  'field.minutesOfMeetings.list.empty2': '새 회의록 작성하기 >',
  'field.minutesOfMeetings.create.cancel.popup.title': '작성한 회의록을 저장하지 않고\n나가시겠어요?',
  'field.minutesOfMeetings.create.cancel.popup.confirm': '네, 나갈게요',
  'field.minutesOfMeetings.create.confirm.popup.title': '작성 완료',
  'field.minutesOfMeetings.create.confirm.popup.content': '최초 작성 이후 24시간 이내로\n수정 가능합니다',

  // recruitment
  'common.notIpAreaText': 'IP 불가 지역',
  'recruitment.join.required': '1. 필수 입력',
  'recruitment.join.options': '2. 선택 입력',
  'common.businessOwner': '대표자명',
  'recruitment.join.title': '나야 시공팀찾기 멤버가입',
  'common.multiSelect.possible': '복수선택 가능',
  'recruitment.majorClients': '주요거래처',
  'recruitment.majorClients.placeholder': '입력후 엔터를 눌러주세요',
  'recruitment.dateEstablishment': '설립일',
  'recruitment.dateEstablishment.placeholder': '설립일 선택',
  'recruitment.numOfEmployee.placeholder': '직원수 선택',
  'recruitment.constructionExperience.placeholder': '시공경력 선택',
  'recruitment.imageBusinessRegistration': '사업자등록증',
  'common.fileUpload.text': '파일 업로드',
  'common.fileUpload.subText': '(jpeg, png, pdf 3mb 이하)',
  'recruitment.managerPhone': '담당자 번호',
  'recruitment.managerPhone.placeholder': '담당자 번호 (-)제외',
  'recruitment.businessPhone': '회사 전화번호',
  'recruitment.businessPhone.placeholder': '회사 전화번호 (-)제외',
  'recruitment.phone.placeholder': '사업자번호(-)제외',
  'recruitment.user.name': '{user} 님',
  'recruitment.address2': '상세주소',
  'footer.body':
    '주식회사 씨투와이 | 대표이사: 문준철\n전화번호: (국번없이)1644-4908\n주소: 서울특별시 마포구 백범로31길 21, 714호 (공덕동, 서울창업허브본관)\n사업자등록번호: 896-81-01068\n계좌번호: 우리은행 1005-904-657215 | KB국민은행 827901-04-135256',
  'footer.footer.left.1': '개인정보처리방침',
  'footer.footer.left.2': '이용약관',
  'footer.footer.left.3': '전자금융거래이용약관',
  'footer.footer.left.4': '고객센터',
  'footer.footer.right': 'ⓒC2Y INC. ALL RIGHT RESERVED',
  'recruitment.capitalStock': '자본금',
  'recruitment.introduce': '회사소개글',
  'recruitment.introduce.placeholder': '직접 작성해주세요',
  'recruitment.doc': '면허 및 증빙자료',
  'recruitment.doc.placeholder': '파일구분 입력',
  'recruitment.doc.errText': '파일구분명을 입력해주세요',
  'recruitment.doc.subtext': '면허, 국세완납증명서, 전년도 재무제표, 신용평가등급확인, 표창장, 감사패 자료 등',
  'recruitment.companyHistories': '회사연혁',
  'recruitment.companyHistories.button': '+ 연혁 추가하기',
  'recruitment.companyHistories.content.placeholder': '내용 입력',
  'recruitment.companyHistories.date.placeholder': '연혁 일자 선택',
  'recruitment.companyHistories.memo': '비고(선택)',
  'recruitment.companyHistories.memo.placeholder': '비고',
  'recruitment.portfolios': '시공실적',
  'recruitment.portfolios.button': '+ 시공실적 추가하기',
  'recruitment.portfolios.images': '시공사진',
  'recruitment.portfolios.fieldName.placeholder': '현장명 입력',
  'recruitment.portfolios.client': '발주처',
  'recruitment.portfolios.client.placeholder': '발주처 입력',
  'recruitment.portfolios.dateStart.placeholder': '시작 일 선택',
  'recruitment.portfolios.dateEnd.placeholder': '종료 일 선택',
  'recruitment.policy.title': '개인정보 처리 관한 동의',
  'recruitment.policy.1': '개인정보 수집 및 이용 동의 (필수)',
  'recruitment.join': '가입하기',
  'recruitment.join.error.empty': '항목을 모두 입력해주세요',
  'recruitment.join.error.invalidPassword': '비밀번호를 8 ~ 12 글자로 입력해주세요',
  'recruitment.join.error.isNotSamePassword': '비밀번호가 서로 다릅니다',
  'recruitment.join.error.agreePrivacyUsage': '개인정보 수집 및 이용 동의는 필수항목입니다',
  'recruitment.join.confirm': '가입되었습니다',
  'err.recruitment.email': '이메일을 입력해주세요',
  'err.recruitment.businessOwner': '대표자명을 입력해주세요',
  'err.recruitment.imageBusinessRegistration': '사업자등록증을 업로드해주세요',
  'err.recruitment.dateEstablishment': '설립일을 선택해주세요',
  'err.recruitment.dateEstablishment.2': '날짜 형식을 확인해주세요(설립일)',
  'err.recruitment.numOfEmployee': '직원수를 선택해주세요',
  'err.recruitment.constructionExperience': '시공경력을 선택해주세요',
  'err.recruitment.companyName': '회사명을 입력해주세요',
  'err.recruitment.typeOfWorks': '주력 공종을 선택해주세요',
  'err.recruitment.constructionSpaceTypes': '주력시공공간을 선택해주세요',
  'err.recruitment.constructionAreas': '시공지역을 선택해주세요',
  'err.recruitment.companyHistories': '회사연혁을 확인해주세요\n내용,일자는 필수항목입니다',
  'err.recruitment.portfolios': '시공실적을 확인해주세요\n현장명,발주처,일자는 필수항목입니다',
  'recruitment.constructionAreas.all': '전국',
  'recruitment.list.guide': '상단에 있는 영역이 최신순입니다',
  'common.autoSave': '저장중...',
  'recruitment.referral': '추천인(선택)',
  'recruitment.referral.placeholder': '상호명 혹은 단체이름',
  'recruitment.go.ERP': '나야 ERP로 이동',
  'recruitment.businessType': '회사형태',
  'recruitment.businessType.placeholder': '회사형태 선택',
  'err.recruitment.businessType': '회사형태를 선택해주세요',
  'recruitment.logo': '로고',

  // transaction
  'search.material.category.0': '카테고리1',
  'search.material.category.1': '카테고리2',
  'transactions.date': '거래일시',
  'transactions.vat': '부가세',
  'transactions.etc': '비고',
  'transactions.supply.price': '공급가액',
  'transactions.startEnd': '거래기간',
  'transactions.sum': '합계금액',
  'transactions.document': '거래명세서',
  'payment.MATERIAL_PAYMENT_COMPANY.CHAI_PORT': '차이포트',
  'sidebar.transaction.transactions': '거래명세표',
  'autocomplete.noOptions': '결과가 없습니다',
  'transactions.deliveryConfirm': '납품확인서',
  'translate.title.info': '거래가 최종 완료된 내역만 표기됩니다.',
  'translate.deliveryConfirm.info.1': '납품확인서 출력',
  'translate.deliveryConfirm.info.2': '의 경우,\n',
  'translate.deliveryConfirm.info.3': '주문취소된 건',
  'translate.deliveryConfirm.info.4': '은 항목에서 제외됩니다\n',
  'translate.deliveryConfirm.info.5': '반품건',
  'translate.deliveryConfirm.info.6': '은 수량에서 마이너스로 표시됩니다',
  'export.transactions': '거래명세서 출력',
  'export.transactions.deliveryConfirm': '납품확인서 출력',
  'transaction.filter.keyword.placeholder': '상품명, 옵션명으로 검색해보세요',

  // transaction/order
  'payment.info': '결제 정보',
  'material.order.number': '주문번호',
  'search.code': '주문번호',
  'sidebar.material.order': '발주내역',
  'sidebar.material.order.detail': '주문 상세',
  'search.field': '현장',
  'order.field.name': '현장',
  'buyer.field': '현장',
  'order.material.etcCount': '건',
  'order.status': '주문 상태',
  'order.status.BIDDING': '입찰 중',
  'order.status.BIDDING_COMPLETE': '입찰 마감',
  'order.status.PAYMENT_CONFIRMING': '결제 중',
  'order.status.READY': '배송 준비',
  'order.status.DELIVERING': '배송 중',
  'order.status.DELIVERY_COMPLETE': '배송 완료',
  'order.status.CONFIRMED': '인수 확인',
  'order.status.REFUND': '환불',
  'order.status.CANCEL': '주문 취소',
  'order.ahaMoveInfo': '배송 정보',
  'selfDelivery.delivery.status.READY': '배송 준비',
  'selfDelivery.delivery.status.IN_TRANSIT': '배송 중',
  'selfDelivery.delivery.status.DELIVERED': '배송 완료',
  'ahaMoves.delivery.status.IDLE': '주문 완료',
  'ahaMoves.delivery.status.ASSIGNING': '배송기사 찾는 중',
  'ahaMoves.delivery.status.ACCEPTED': '배정 완료',
  'ahaMoves.delivery.status.IN_PROCESS': '적재 완료',
  'ahaMoves.delivery.status.COMPLETED': '배송 완료',
  'ahaMoves.delivery.status.CANCELLED': '배송 취소',
  'material.info': '상품 정보',
  'payment.logiSpot.carType.0': '오토바이',
  'payment.logiSpot.carType.1': '다마스',
  'payment.logiSpot.carType.2': '라보',
  'payment.logiSpot.carType.3': '카고/윙',
  'payment.logiSpot.carType.4': '카고',
  'payment.logiSpot.carType.5': '윙바디',
  'payment.logiSpot.carType.6': '탑',
  'payment.logiSpot.carType.7': '냉동',
  'payment.logiSpot.carType.8': '냉장',
  'payment.logiSpot.carType.10': '트레일러',
  'payment.logiSpot.carType.11': '컨테이너',
  'payment.logiSpot.carType.12': '방통차',
  'payment.logiSpot.carType.13': '사다리차',
  'payment.logiSpot.carType.14': '지게차',
  'payment.logiSpot.carTon.0.3': '0.3톤',
  'payment.logiSpot.carTon.0.5': '0.5톤',
  'payment.logiSpot.carTon.1': '1톤',
  'payment.logiSpot.carTon.1.4': '1.2톤',
  'payment.logiSpot.carTon.2.5': '2.5톤',
  'payment.logiSpot.carTon.3.5': '3.5톤',
  'payment.logiSpot.carTon.5': '5톤',
  'payment.logiSpot.carTon.5P': '5톤플러스',
  'payment.logiSpot.carTon.5W': '5톤축',
  'payment.logiSpot.carTon.11': '11톤',
  'payment.logiSpot.carTon.11W': '11톤축',
  'payment.logiSpot.carTon.18': '18톤',
  'payment.logiSpot.carTon.25': '25톤',
  'payment.logiSpot.carTon.20FT': '20피트',
  'payment.logiSpot.carTon.40FT': '40피트',
  'payment.logiSpot.carTon.1LAD': '1톤(최대8층)',
  'payment.logiSpot.carTon.2.5LAD': '2.5톤(최대13층)',
  'payment.logiSpot.carTon.3.5LAD': '3.5톤(최대16층)',
  'payment.logiSpot.carTon.5LAD': '5톤(최대 25층)',
  'payment.logiSpot.carTon.6LAD': '6톤(최대 25층)',
  'payment.logiSpot.carTon.7.5LAD': '7.5톤(최대 25층)',
  'payment.logiSpot.carTon.10LAD': '10톤(최대 25층)',
  'payment.logiSpot.carTon.FORKLIFT': '지게차',
  'delivery.logiSpot.status.ASSIGNING': '배송기사 찾는 중',
  'delivery.logiSpot.status.ACCEPTED': '배차완료',
  'delivery.logiSpot.status.LOAD_COMPLETE': '상차완료',
  'delivery.logiSpot.status.UNLOAD_COMPLETE': '하차완료',
  'delivery.logiSpot.status.REQUEST_CANCEL': '취소요청',
  'delivery.logiSpot.status.REQUEST_MODIFY': '수정요청',
  'payment.MATERIAL_PAYMENT_METHOD.CREDIT': '외상',
  'payment.MATERIAL_PAYMENT_METHOD.TRANSFER': '계좌이체',
  'payment.MATERIAL_PAYMENT_METHOD.CARD_AUTO': '카드 자동 결제',
  'payment.MATERIAL_PAYMENT_METHOD.VIRTUAL_ACCOUNT': '가상 계좌',
  'payment.MATERIAL_PAYMENT_METHOD.REAL_TIME_TRANSFER': '실시간 계좌이체',
  'payment.MATERIAL_PAYMENT_COMPANY.SELF': '직접거래',
  'payment.MATERIAL_PAYMENT_COMPANY.TOSS': '토스페이먼츠',
  'payment.datePaid': '결제일',
  'common.sum': '합계',
  'delivery.sum': '합계',
  'order.isImmediateDelivery': '즉시배송',
  'order.isImmediateDelivery.false': '예약배송',
  'sidebar.material.refund.cancel': '주문취소',
  'sidebar.material.refund.return': '반품',
  'material.refund.dateCreated': '주문일',
  'material.refund.orders.material': '상품',
  'order.history.type.material': '상품',
  'order.cancel.item.item': '상품',
  'order.return.item.item': '상품',
  'material.refund.delivery.type.SELF_DELIVERY': '자체배송',
  'material.refund.delivery.type.LOGI_SPOT': '로지스팟',
  'material.refund.delivery.type.AHA_MOVES': 'AhaMoves',
  'material.order.payment.isPaid': '결제여부',
  'material.order.item': '항목',
  'order.cancel.item': '항목',
  'order.return.item': '항목',
  'material.order.price': '단가',
  'order.cancel.item.amount': '단가',
  'order.return.item.amount': '단가',
  'material.delivery.recipients': '인수자(최대 3명)',
  'material.delivery.dateRequiredDelivery': '납품요청일',
  'material.payment.amountMaterials': '상품합계',
  'material.payment.amountDeliverys': '배송비합계',
  'MATERIAL_RETURN_STATUS.REQUEST': '반품 접수',
  'MATERIAL_RETURN_STATUS.RETURNING': '반품 회수중',
  'MATERIAL_RETURN_STATUS.COMPLETE': '반품 완료',
  'MATERIAL_RETURN_STATUS.REJECT': '반려',
  'return.deliveryMethod': '반품배송방법',
  'return.charger': '과실',
  'MATERIAL_RETURN_CHARGER.BUYER': '구매자',
  'MATERIAL_RETURN_CHARGER.SELLER': '판매자',
  'MATERIAL_RETURN_CHARGER.DELIVERY_COMPANY': '배송업체',
  'MATERIAL_RETURN_REASON.BUYER_1': '단순변심(구매자과실)',
  'MATERIAL_RETURN_REASON.SELLER_1': '불량(판매자과실)',
  'MATERIAL_RETURN_REASON.SELLER_2': '오배송(판매자과실)',
  'MATERIAL_RETURN_REASON.SELLER_3': '자체배송 파손(판매자과실)',
  'MATERIAL_RETURN_DELIVERY_METHOD.NAYA': '나야 배송',
  'MATERIAL_RETURN_DELIVERY_METHOD.BUYER': '구매자 자체 배송',
  'MATERIAL_RETURN_DELIVERY_METHOD.SELLER': '판매자 자체 배송',
  'MATERIAL_RETURN_DELIVERY_METHOD.DROP': '폐기',
  'payment.logiSpot.carTon.MOTO': '오토바이',
  'order.history': '주문내역',
  'MATERIAL_ORDER_STATUS.READY_REGISTRATE': '재고확인 중',
  'MATERIAL_ORDER_STATUS.BIDDING': '재고확인 중',
  'MATERIAL_ORDER_STATUS.PAYMENT_CONFIRMING': '결제 중',
  'MATERIAL_ORDER_STATUS.DELIVERING': '배송 중',
  'MATERIAL_ORDER_STATUS.CANCEL': '주문 취소',
  'MATERIAL_ORDER_STATUS.RETURN': '반품',
  'MATERIAL_ORDER_STATUS.BIDDING.SELLER': '판매자 재고확인 중',
  'MATERIAL_ORDER_STATUS.BIDDING.BUYER': '구매자 견적확인 중',
  'common.totalSum': '총 합계',
  'MATERIAL_DELIVERY_STATUS.READY': '배송 준비',
  'MATERIAL_DELIVERY_STATUS.DELIVERING': '배송 중',
  'MATERIAL_DELIVERY_STATUS.CONFIRMED': '배송 완료',
  'payment.MATERIAL_PAYMENT_METHOD.CARD': '카드 결제',
  'delivery.logiSpot.status.BEFORE': '배차 전',
  'order.info': '주문 상세',
  'material.refund.cancel.history': '결제 후 주문취소에 대한 환불내역',
  'material.refund.return.history': '반품에 대한 환불내역',
  'order.history.inspector': '인수자',
  'order.history.type.delivery': '배송',
  'order.history.type.otherCosts': '환불배송비(기타)',
  'order.cancel.staff': '취소 요청자',
  'order.cancel.dateCreated': '취소 요청일',
  'order.cancel.refundAmount': '환불 금액',
  'order.return.refundAmount': '환불 금액',
  'order.cancel.result': '환불 처리 결과',
  'order.return.result': '환불 처리 결과',
  'order.cancel.result.method': '환불방법',
  'order.return.result.method': '환불방법',
  'order.cancel.result.date': '환불일자',
  'order.return.result.date': '환불일자',
  'order.cancel.result.date.notYet': '환불 진행중',
  'order.return.staff': '환불 요청자',
  'order.return.dateRequired': '환불 요청일',
  'order.return.status': '반품상황',
  'order.return.reason': '사유',
  'order.return.detailReason': '상세 사유',
  'order.return.address': '구매자\n반품 주소',
  'order.return.deliveryMethod': '반품배송방법',
  'order.return.charger': '과실',
  'order.return.item.deliveryStatus': '배송상황',
  'order.return.item.delivery.SELF_DELIVERY': '판매자 자체배송',
  'order.return.item.delivery.LOGI_SPOT': '로지스팟 배송',
  'order.return.item.delivery.AHA_MOVES': 'AhaMoves',
  'material.refund.delivery.type.SELLER_DELIVERY': '판매자 자체배송',
  'transactions.otherCosts': '기타비용',
  'delivery.unit': '대',
  'transactions.date.now': '이번달',
  'transactions.export': '출력하기',
  'field.workLog.detail.32': '출력하기',
  'MATERIAL_ORDER_STATUS.DELIVERY_COMPLETE': '거래(인수 완료)',
  'transactions.date.prev': '지난달',
  'material.order.list.item': '항목(단위 원, 부가세 포함)',
  'MATERIAL_RETURN_REASON.DELIVERY_1': '배송 불만(배송업체과실)',
  'MATERIAL_RETURN_REASON.NAYA_1': '전산오류(나야과실)',
  'MATERIAL_RETURN_CHARGER.NAYA': '나야',
  'common.discounts': '할인',
  'order.discounts.FLOOR': '단수정리',
  'sum.discounts': '할인합계',
  'order.top.message2': '[바로가기]',
  'sidebar.transaction.order': '실시간 주문 내역',
  'order.top.message1': '거래가 완료된 금액은 거래명세표를 확인하세요. ',
  'order.price.vat': '단가(VAT 별도)',
  'common.sum.vat': '합계(부가세 포함)',
  'button.add.update': '추가/수정',
  'common.options': '옵션',
  'order.recipients.name': '인수자 성명',
  'order.dateRequiredDelivery': '희망 도착 일시',
  'select.option.message': '옵션을 선택해 주세요.',
  'dashboard.right.1': '(단위: 원)',
  'order.list.checkList': '체크사항',
  'order.confirm.title': '발주요청 완료',
  'order.confirm.message1': '재고 여부와 배송비가 확인되면\n결제 알람을 드립니다',
  'order.confirm.message2': '나야 앱을 설치해주세요',
  'order.confirm.yes': '설치하러 가기',
  'order.inquiry.message1': '투입 예정 자재 접수',
  'order.inquiry.message2': '직접 일일이 구매 자재를 찾지 마세요!\n현장 투입 예정 자재 리스트(계약 내역서 등) 사진을 주시면\n여기에 저희가 업로드 해드려요 (당일 불가)',
  'button.uploadFile': '파일 업로드',
  'order.inquiry.title': '투입 예정 자재 접수',
  'button.sendPhoto': '사진 보내기',
  'order.inquiry.complete': '전송 완료',
  'order.inquiry.message': '업로드 완료 시 발주가 가능합니다\n완료되면 알림으로 알려드릴게요',
  'order.estimate.price': '특별견적가',
  'transaction.order.detail.button.virtualAccount': '무통장입금',
  'transaction.order.detail.button.card': '카드결제',
  'transaction.order.detail.button.credit': '외상거래',
  'transaction.order.detail.popup.payment.before.title': '결제 전 알림',
  'transaction.order.detail.popup.payment.before.contents':
    '결제 이후에는 발주 취소가 불가하기에 입금 전 발주서를 다시 확인하시기를 부탁드립니다.\n\n* 결제 완료 후 납품 일자에 맞춰서 배송이 진행됩니다.\n\n결제를 진행하시겠습니까?',
  'transaction.order.detail.popup.payment.before.customer.name': '입금자명을 입력해주세요',
  'transaction.order.detail.popup.payment.before.registration.number': '(-)없이 사업자번호를 입력해주세요',
  'transaction.order.detail.popup.payment.before.customer.email': '결제 정보 받을 이메일을 입력해주세요',
  'transaction.order.detail.popup.payment.before.bank': '은행 선택',
  'transaction.order.detail.popup.payment.credit.title': '외상으로 결제하시겠어요?',
  'transaction.order.detail.popup.payment.credit.available': '외상 한도 잔액',
  'transaction.order.detail.popup.payment.credit.expected': '결제 예정금액',
  'transaction.order.detail.popup.payment.credit.remains': '결제 후 외상한도잔액',
  'transaction.order.detail.popup.payment.complete': '결제가 완료되었습니다.',
  'transaction.order.detail.popup.payment.complete.error': '결제에 실패하였습니다. 잠시 후 다시 시도해주세요.',
  'transaction.order.detail.popup.payment.virtual.account.customer.name': '입금자명',
  'transaction.order.detail.popup.payment.virtual.account.bank': '입금계좌 은행',
  'transaction.order.detail.popup.payment.virtual.account.registration.number': '사업자(지출증빙)',
  'transaction.order.detail.popup.payment.virtual.account.button': '가상계좌 발급하기',
  'transaction.order.detail.popup.payment.virtual.account.bank.required': '은행을 선택해주세요',
  'transaction.order.detail.popup.payment.virtual.account.customer.name.required': '입금자명을 입력해주세요',
  'transaction.order.detail.popup.payment.virtual.account.registration.number.required': '사업자(지출증빙)를 입력해주세요',
  'transaction.order.detail.popup.payment.virtual.account.complete.title': '가상계좌 결제 안내',
  'search.statuses': '상태(중복선택)',
  'order.tracking.number.update.trackingNumber': '송장번호',

  // field/budget
  'material.category0.name': '카테고리1',
  'material.category1.name': '카테고리2',
  'material.category4.name': '상품명',
  'material.no': '상품코드',
  'seller.material.name': '상품명',
  'common.budget': '예산',
  'buyer.field.budget': '예산',
  'add.budget': '예산 추가',
  'b2c.material.keywords': '키워드',
  'buyer.field.budget.update': '예산 수정',
  'buyer.quantityRequired.total': '총 실행예산수량',
  'search.material': '자재 추가',
  'buyer.field.budget.add': '예산 입력',
  'error.duplicate': '중복된 항목이 존재합니다.',
  'common.required': '필수입력사항 입니다.',
  'budget.date.no': '희망일자없음',
  'button.add.quantity.date': '일자 / 수량 추가',
  'buyer.field.budget.date': '발주알림 희망일자',
  'buyer.field.budget.date.option': '발주알림 희망일자(선택 사항)',
  'buyer.field.budget.quantity': '일자별 수량',
  'common.memo.option': '메모(선택사항)',
  'field.buyed': '구매',
  'field.amountRequired': '금액\n(기준단가)',
  'field.budget.delete.group': '예산 일괄 삭제',
  'field.budget.delete': '예산 삭제',
  'field.title.budget': '예산관리',
  'field.budget.request.list': '예산 요청 목록 보기',
  'field.budget.request': '예산 요청',
  'field.budget.request.info': '요청인 정보',
  'field.budget.request.info.name': '요청인 성함',
  'field.budget.request.info.date': '요청일',
  'field.budget.request.material': '예산 요청 자재',
  'field.budget.request.list.more': '외 {num}건',
  'field.budget.empty': '예산없음',

  // calendar
  'calendar.prev': '지난 달',
  'calendar.now': '현재',
  'calendar.next': '다음 달',
  'common.year': '년',
  'common.month': '월',
  'calendar.budget': '발주알림희망일자',
  'calendar.budget.time': '08:00',
  'calendar.budget.setting': '발주알림희망일자 관리',
  'calendar.budget.add': '발주알림희망일자 추가',
  'field.schedule.isNoty': '알림 여부',
  'field.schedule.noty': '푸시 알림',
  'calendar.message.2': '오전 8:00 에 앱으로\n푸시 알림이 갑니다',
  'sidebar.material.order.calendar': '일정',
  'calendar.plan': '일정 메모',
  'calendar.delivery.date': '납품 확정',
  'calendar.order': '결제 대기',
  'calendar.plan.add': '일정 및 알림 설정',
  'calendar.field.placeholder': '현장 선택',
  'calendar.message.1': '일정과 알림을 설정하시면 앱으로\n해당 일시에 스케줄 알림을 드립니다',

  // dashboard
  'transactions.material': '품목',
  'dashboard.field.order': '자재주문',
  'dashboard.field.contract': '전자계약',
  'dashboard.field.budget': '예산관리',
  'dashboard.field.meeting': '회의록',
  'dashboard.field.item': '품목별 거래내역',
  'dashboard.field.budget.setting': '예산수량 설정',
  'dashboard.field.transaction': '거래명세표 확인/출력',
  'common.rank': '순위',
  'dashboard.field.order.quantity': '발주수량',
  'dashboard.field.budget.quantity': '예산수량',
  'dashboard.field.average.amount': '평균단가',
  'dashboard.field.order.material.empty': '거래내역이 없습니다.',
  'dashboard.field.order.material.empty.link': '자재 발주하기 >',

  // setting
  'buyer.favorite': '즐겨찾기',
  'buyer.favorite.quantityCompleted': '실행완료수량',
  'favorite.add.update': '즐겨찾기 추가/수정',
  'title.field.subFields': '협력업체',
  'field.surField': '발주처',
  'favorite.manage': '즐겨찾기 관리',

  // field/contract
  'field.contract': '전자계약',
  'field.contract.label.constructionInfo.name': '공사명을 입력해주세요',
  'field.contract.label.constructionInfo.address': '공사 장소를 입력해주세요',
  'field.contract.label.constructionInfo.dateStart': '착공일자를 선택해주세요',
  'field.contract.label.constructionInfo.dateEnd': '준공일자를 선택해주세요',
  'field.contract.label.contractAmount.supply': '공급가액을 입력해주세요',
  'field.contract.label.contractAmount.memoTotal': '총공사 금액 비고를 작성해주세요',
  'field.contract.label.contractAmount.memoSupply': '공급가액 비고를 작성해주세요',
  'field.contract.label.contractAmount.memoVat': '부가세 비고를 작성해주세요',
  'field.contract.label.payment.advance': '선급금을 입력해주세요',
  'field.contract.label.payment.interim1st': '1차 중도금을 입력해주세요',
  'field.contract.label.payment.dueDays1st': '1차 중도금 지급조건을 입력해주세요',
  'field.contract.label.payment.interim2st': '2차 중도금을 입력해주세요',
  'field.contract.label.payment.dueDays2st': '2차 중도금 지급조건을 입력해주세요',
  'field.contract.label.defects.yearsOfLiability': '하자담보책임기간을 입력해주세요',
  'field.contract.label.defects.rateOfRepairDeposit': '하자보수보증금율을 입력해주세요',
  'field.contract.label.defects.rateOfLiquidation': '지체상금율을 입력해주세요',
  'field.contract.label.contractInfo': '계약일을 선택해주세요',
  'field.contract.label.contractInfo.contractor.name': '고객 성명(또는 상호)을 입력해주세요',
  'field.contract.label.contractInfo.contractor.contact': '고객 연락처를 작성해주세요',
  'field.contract.label.contractInfo.contractor.address': '고객 주소를 입력해주세요',
  'field.contract.label.contractInfo.recipient.name': '대표자명(또는 상호명)을 입력해주세요',
  'field.contract.label.contractInfo.recipient.contact': '연락처를 작성해주세요',
  'field.contract.label.contractInfo.recipient.businessNumber': '사업자번호를 입력해주세요',
  'field.contract.label.contractInfo.recipient.address': '사업장 주소를 입력해주세요',
  'field.contract.placeholder.contractInfo.recipient.name': '성명을 입력해주세요',
  'field.contract.placeholder.constructionInfo.name': '공사명을 입력해주세요',
  'field.contract.placeholder.contractInfo.contractor.name': '성명을 입력해주세요',
  'field.contract.placeholder.defects.yearsOfLiability': '기간을 입력해주세요',
  'field.contract.placeholder.defects.rateOfRepairDeposit': '비율을 입력해주세요',
  'field.contract.placeholder.defects.rateOfLiquidation': '비율을 입력해주세요',
  'field.contract.placeholder.payment.dueDays1st': 'ex) 공정률 30% 완성 합의 후 2일내',
  'field.contract.placeholder.payment.dueDays2st': 'ex) 공정률 70% 완성 합의 후 2일내',
  'field.contract.placeholder.contractAmount.memoTotal': '(선택) 비고를 작성해주세요',
  'field.contract.placeholder.contractAmount.memoSupply': '(선택) 비고를 작성해주세요',
  'field.contract.placeholder.contractAmount.memoVat': '(선택) 비고를 작성해주세요',
  'field.contract.placeholder.address': '주소지를 입력해주세요',
  'field.contract.empty.page': '계약서 내용을 꼼꼼하게 확인해주세요',
  'field.contract.contents.placeholder.constructionInfo.name': '#공사명',
  'field.contract.contents.placeholder.constructionInfo.address': '#공사장소',
  'field.contract.contents.placeholder.constructionInfo.dateStart': '#착공일자',
  'field.contract.contents.placeholder.constructionInfo.dateEnd': '#준공일자',
  'field.contract.contents.placeholder.contractAmount.total': '#총공사 금액',
  'field.contract.contents.placeholder.contractAmount.vat': '#부가세',
  'field.contract.contents.placeholder.contractAmount.supply': '#공급가액',
  'field.contract.contents.placeholder.contractAmount.memoTotal': '#비고',
  'field.contract.contents.placeholder.contractAmount.memoSupply': '#비고',
  'field.contract.contents.placeholder.contractAmount.memoVat': '#비고',
  'field.contract.contents.placeholder.payment.advance': '#선급금',
  'field.contract.contents.placeholder.payment.interim1st': '#1차 중도금',
  'field.contract.contents.placeholder.payment.dueDays1st': '#지급조건',
  'field.contract.contents.placeholder.payment.dueDays1st.2': '#지급조건',
  'field.contract.contents.placeholder.payment.interim2st': '#2차 중도금',
  'field.contract.contents.placeholder.payment.dueDays2st': '#지급조건',
  'field.contract.contents.placeholder.payment.dueDays2st.2': '#지급조건',
  'field.contract.contents.placeholder.payment.balance': '#잔금',
  'field.contract.contents.placeholder.defects.yearsOfLiability': '#숫자',
  'field.contract.contents.placeholder.defects.rateOfRepairDeposit': '#숫자',
  'field.contract.contents.placeholder.defects.rateOfLiquidation': '#숫자',
  'field.contract.contents.placeholder.contractInfo.contractor.name': '#도급인 성명(또는 상호)',
  'field.contract.contents.placeholder.contractInfo.contractor.contact': '#도급인 연락처',
  'field.contract.contents.placeholder.contractInfo.contractor.address': '#도급인 주소',
  'field.contract.contents.placeholder.contractInfo.recipient.name': '#수급인 성명',
  'field.contract.contents.placeholder.contractInfo.recipient.contact': '#수급인 연락처',
  'field.contract.contents.placeholder.contractInfo.recipient.businessNumber': '#사업자번호',
  'field.contract.contents.placeholder.contractInfo.recipient.address': '#수급인 주소',
  'field.contract.label.specialProvisions': '특약사항을 입력해주세요 (선택)',
  'field.contract.button.specialProvisions': '특약사항 수정하기',
  'field.contract.check.empty.specialProvisions': '특약사항 미작성하기',
  'field.contract.empty.specialProvisions': '특약사항 없음',
  'field.contract.contents.placeholder.specialProvisions': '#특약사항',
  'field.specialProvisions.popup.title': '특약사항',
  'field.contract.fill.form': '양식 채우기',
  'field.contract.new': '새 계약서 작성',
  'field.contract.fileName': '서류명',
  'field.contract.requestDate': '요청일',
  'field.contract.contractDate': '체결일',
  'field.contract.counterpart': '상대방',
  'field.contract.empty.text': '등록된 문서가 없습니다.',
  'field.contract.empty.create': '계약서 새로 생성하기 >',
  'field.contract.label.attachments.sub': '* 10MB 이하 파일만 업로드 가능합니다.',
  'field.contract.label.attachments.1': '1. 산출내역서',
  'field.contract.label.attachments.2': '2. 설계서',
  'field.contract.file': '계약 첨부 서류',
  'field.contract.title': '인테리어 공사 도급 계약서',
  'common.cancel.draft': '작성취소',
  'field.contract.request.signature': '계약서 발행하기',
  'field.contract.cancel.popup.title': '저장하지 않은 내용은 사라집니다.\n취소하시겠어요?',
  'moduSign.before.popup.title': '계약서를 발행할까요?',
  'moduSign.before.popup.contents': '계약서를 모두 작성 및 검토하셨나요?\n발행 시 수정이 불가능합니다.',
  'moduSign.before.popup.yes': '네, 발행할게요',
  'moduSign.after.popup.title': '카카오톡으로 전송 완료',
  'moduSign.after.popup.contents': '발행된 계약서를 카카오톡으로 전송했어요\n전자계약서 확인 및 서명을 해주세요',
  'common.go.back': '뒤로가기',
  'field.contract.remindSigning': '서명 요청 재전송하기',
  'contract.status.contract.status.TEMP': '작성중',
  'contract.status.contract.status.ON_PROCESSING': '문서 처리 중',
  'contract.status.contract.status.ON_GOING': '내 서명 필요',
  'contract.status.contract.status.ON_GOING.signed': '상대 서명 대기중',
  'contract.status.contract.status.ABORTED': '계약취소',
  'contract.status.contract.status.COMPLETED': '계약완료',
  'error.constructionInfo.dateEnd': '착공일자 기준 최소 1일 이상 지난 날짜로 선택해주세요',
  'field.contract.example.button': '예시계약서 보기',
  'field.contract.label.attachments.quote': '계약 첨부 서류 2가지를 등록해주세요',

  // field/account-book
  'field.account.book.staff': '투입직원',
  'field.account.book.open': '펼쳐보기',

  // staff
  'sidebar.material.staff': '조직 관리',
  'staff.list.register': '직원 등록',
  'staff.list.current': '현재 직원',
  'staff.list.restricted': '접속 제한',
  'staff.list.search': '직원 검색',
  'staff.list.filter': '필터',
  'staff.filter.position': '직급',
  'staff.filter.position.input': '직급 입력',
  'staff.filter.date.start': '시작일',
  'staff.filter.date.end': '종료일',
  'staff.filter.date.entered': '입사일',
  'staff.filter.date.resignation': '퇴사일',
  'staff.filter.apply': '적용',
  'staff.filter.close': '닫기',
  'staff.list.department': '조직도',
  'staff.list.department.edit': '편집',
  'staff.list.department.total': '전체',
  'staff.list.department.unassigned': '미배정',
  'staff.create.title': '직원 등록',
  'staff.create.basic.info': '기본 정보',
  'staff.create.basic.info.name': '이름',
  'staff.create.basic.info.name.placeholder': '이름을 입력하세요.',
  'staff.create.basic.info.required.hint': '필수 입력 사항입니다.',
  'staff.create.basic.info.password': '비밀번호',
  'staff.create.basic.info.password.placeholder': '비밀번호를 입력하세요.',
  'staff.create.basic.info.phone': '연락처',
  'staff.create.basic.info.phone.placeholder': '연락처를 입력하세요.',
  'staff.create.basic.info.phone.hint': "'-'없이 숫자만 입력해주세요.",
  'staff.create.basic.info.birthday': '생년월일',
  'staff.create.basic.info.birthday.placeholder': '날짜 선택',
  'staff.create.basic.info.department.title': '조직 내 정보',
  'staff.create.basic.info.department': '부서',
  'staff.create.basic.info.department.empty': '없음',
  'staff.create.basic.info.department.unassigned': '미편성',
  'staff.create.basic.info.position': '직급',
  'staff.create.basic.info.position.placeholder': '직급명을 입력하세요.',
  'staff.create.basic.info.permission': '계정 접속',
  'staff.create.basic.info.permission.allow': '허용',
  'staff.create.basic.info.permission.restrict': '제한',
  'staff.create.basic.info.date.entered': '입사일',
  'staff.create.basic.info.date.entered.placeholder': '입사일을 선택하세요.',
  'staff.create.basic.info.date.resignation': '퇴사일',
  'staff.create.basic.info.date.resignation.placeholder': '퇴사일을 선택하세요.',
  'staff.create.basic.info.profile': '프로필',
  'staff.create.basic.info.profile.upload.placeholder': '첨부할 파일을 여기에 끌어다 놓거나, 업로드 버튼을 통해 직접 선택해주세요',
  'staff.create.basic.info.profile.upload': '파일 업로드',
  'staff.create.basic.info.profile.upload.hint': '5MB 이하의 이미지 파일만 업로드 가능합니다.',
  'staff.create.basic.info.memo': '메모',
  'staff.create.basic.info.memo.placeholder': '메모를 입력하세요.',
  'staff.create.basic.info.memo.hint': '작성한 내용은 직원에게 노출되지 않습니다.',
  'staff.create.basic.info.register': '직원 등록',
  'staff.create.basic.info.cancel': '취소',
  'staff.create.basic.info.warning.title': '구성원 등록을 취소할까요?',
  'staff.create.basic.info.warning.subtitle': '작성한 내용은 저장되지 않습니다.',
  'staff.create.basic.info.warning.confirm': '등록 취소',
  'basic.input.required': ' (필수)',
  'staff.list.empty': '현재 등록된 직원이 없습니다.',
  'staff.list.empty.search': '검색 결과가 없습니다.',
  'staff.list.id': '사번',
  'staff.list.inactive.change': '재직 중으로 변경',
  'staff.list.inactive.change.button': '접속 제한 해제',
  'staff.list.inactive.change.success.1': '{name}의 접속 제한을 해제하였습니다.',
  'staff.list.inactive.change.success.2': '{name} 외 {count}명 접속 제한을 해제하였습니다.',
  'staff.list.department.edit.mode': '현재 조직도 편집을 위한 편집 모드 상태입니다.',
  'staff.list.department.delete.title': '부서를 삭제하시겠습니까?',
  'staff.list.department.delete.sub': '해당 부서의 직원은 삭제시 미배정 직원으로 분류됩니다.',
  'staff.list.department.delete': '부서 삭제',
  'staff.list.department.edit.name': '부서명 변경',
  'staff.list.department.create': '새로운 부서',
  'staff.list.edit.mode.exit': '편집 모드 종료',
  'staff.list.department.move': '부서 이동',
  'staff.list.inactive.limit': '접속 제한',
  'staff.list.inactive.limit.title': '선택한 직원을 접속 제한 처리할까요?',
  'staff.list.inactive.limit.sub': '접속 제한 처리된 직원은 로그인할 수 없습니다.',
  'button.move': '이동',
  'staff.list.department.move.input.placeholder': '이동할 부서 선택',
  'staff.list.active.change.success.1': '{name}의 접속을 제한하였습니다.',
  'staff.list.active.change.success.2': '{name} 외 {count}명 접속을 제한하였습니다.',
  'staff.detail.title': '직원 정보',
  'staff.detail.fields': '담당 현장',
  'staff.detail.update.info': '직원 정보 수정',
  'staff.detail.update.password': '비밀번호 변경',
  'staff.detail.update.password.hint': '비밀번호 변경은 구성원 정보 페이지 우측 상단에 있습니다.',
  'staff.modify.success': '저장 완료되었습니다.',
  'staff.modify.title': '정보 수정',
  'staff.detail.update.password.placeholder': '변경할 비밀번호를 입력하세요.',
  'button.modify.password': '변경',
  'staff.detail.update.password.success': '비밀번호를 변경하였습니다.',
  'staff.detail.info.body.memo.title': '직원 메모',
  'staff.detail.info.body.memo.button.collapse': '접기',
  'staff.detail.info.body.memo.button.expand': '펼치기',
  'staff.detail.info.body.contents.title': '기본 정보',
  'staff.detail.info.body.department.title': '조직 내 정보',
  'staff.detail.info.body.permission.allow': '허용',
  'staff.detail.info.body.permission.restrict': '접속 제한',
  'staff.detail.info.body.work.title': '근무 이력',
  'staff.detail.info.body.work.period': '재직 기간',
  'staff.detail.info.body.work.entered': '입사일',
  'staff.detail.info.body.work.resigned': '퇴사일',
  'staff.detail.field.search': '현장명 검색',
  'staff.detail.field.ledger.sales': '매출액',
  'staff.detail.field.ledger.profit': '현재 수익',
  'staff.detail.field.ledger.receivable': '미수금 총액',
  'staff.detail.field.construct.status.WORKING': '시공진행중',
  'staff.detail.field.construct.status.DUMMY': '수주 보류',
  'staff.detail.field.construct.status.CONSULTING': '상담중',
  'staff.detail.field.construct.status.COMPLETE': '시공 완료',
  'staff.detail.field.footer.staff': '담당직원',
  'staff.detail.field.footer.profit': '현장손익',
  'staff.detail.field.empty': '담당 현장이 없습니다.',
  'staff.role': '권한',
  'staff.role.MEMBER': '직원',
  'staff.role.SUPERVISOR': '관리자',
  'common.won': '원',
  'staff.detail.field.empty.permission1': '관련 권한이 없습니다.',
  'staff.detail.field.empty.permission2': '사내 담당자에게 문의해주세요.',
  'staff.update.popup.header.select': '선택 직원',
  'staff.update.popup.header.all': '전체',
  'staff.update.popup.header.restricted': '접속 제한 직원 보기',
  'staff.update.popup.header.leave.title': '현장을 나가시겠습니까?',
  'staff.update.popup.header.leave.confirm': '나가기',

  'field.add.update.empty.title': '먼저 현장을 등록해주세요',
  'field.add.update.empty.sub': '새 현장 등록 후 이용가능합니다.\n바로 현장을 생성하시겠어요?',
  'field.add.update.empty.button': '현장 등록하기',

  'customer.support.chat.header': '나야 채팅',
  'customer.support.chat.input.placeholder': '메시지를 입력해주세요',
  'customer.support.chat.input.button': '보내기',
  'customer.support.chat.default.message': '나야 고객센터',

  'staff.list.search.result.1': '에 대한 검색 결과',
  'staff.list.search.result.2': '총',
  'staff.list.search.result.3': '명',

  'staff.list.filter.all': '적용 필터 {count}',
  'customer.support.chat.input.file.size': '파일은 200MB까지 첨부할 수 있습니다.',

  'upload.business.registration.view.title': '사업자등록증 (필수)',
  'upload.business.registration.view.upload.text': '파일 업로드',
  'upload.business.registration.view.hint': '용량이 10mb 이상인 파일은 업로드가 제한됩니다.',

  'order.shopping.cart': '장바구니',
  'order.confirm': '자재 발주서',
  'order.complete': '발주 요청 완료',
  'order.search.placeholder': '자재명 입력',
  'order.type.BASIC': '전체상품',
  'order.type.BUDGET': '내현장자재',
  'order.type.FAVORITE': '즐겨찾기',
  'order.search.result': '‘에 대한 검색 결과입니다.',
  'order.divider.button.text': '나야채팅',
  'order.divider.text.1': '보이는 가격보다 저렴하게 발주하고 싶다면?',
  'order.divider.text.2': '견적서만 있으면 빠르게 자재 세팅해드려요!',
  'order.divider.text.3': '어떤 업무든 OK! 나야 상담원과 직접 소통하세요',
  'common.all': '전체',

  'material.area.header.all.title': '총',
  'material.area.header.all.count': '개',
  'material.area.header.all.product': '상품',

  'material.area.empty.title': '검색된 자재가 없습니다.',
  'material.area.empty.sub': '다른 검색어를 사용하시거나 나야 채팅으로 문의해주세요',
  'material.area.empty.favorite.title': '현재 즐겨찾기에 등록된 자재가 없습니다.',
  'material.area.empty.favorite.sub': '우리 회사가 자주 구매하는 자재를 즐겨찾기에 등록해보세요.',

  'material.area.budget.empty.label': '자재 세팅',
  'material.area.budget.empty.title': '현장에 사용될 자재 리스트를\n보내주시면 이곳에 세팅됩니다.',
  'material.area.budget.empty.subtitle': '사용하실 자재 리스트를 엑셀, 화면 캡처 이미지 등 형식에 관계없이\n보내주시기만 하면 바로 구매하실 수 있게 이곳에 세팅해드려요.',
  'material.area.budget.empty.button': '자재 리스트 보내기',
  'material.estimate': '특별할인',

  'material.budget.notice': '내현장자재는 보내주신 견적서를 기반으로 생성된 자재 목록입니다.',
  'material.favorite.notice': '즐겨찾기의 자재 목록은 모든 직원이 공유합니다.',

  'footer.company.name': '(주)씨투와이(C2Y)',
  'footer.company.representative': '대표이사 : 문준철',
  'footer.company.business.number': '사업자등록번호 : 896-81-01068',
  'footer.company.communication.number': '통신판매업신고번호 : 제2025-서울마포-2127호',
  'footer.company.address': '주소 : 서울시 마포구 330. 318호 (상암동, 디엠씨첨단산업센터)',
  'footer.company.email': '이메일 문의 : info@nayac2y.com',
  'footer.company.time': '운영시간 : 08:30 ~ 18:00',
  'footer.company.phone': '전화문의 : 1644-4908',
  'footer.company.copyright': 'Copyright',
  'footer.company.copyright.text': '© ️C2Y.',
  'footer.company.all.rights.reserved': 'All Rights Reserved',
  'footer.company.phone.text': '문의 1644-4908',
  'footer.company.time.text': '오전 08시 30분 ~ 오후 05시 30분',
  'footer.company.time.text.2': '주말 및 공휴일은 휴무입니다',
  'order.addToCart.description': '발주 요청에 따라 배송비가 책정됩니다.',
  'order.addToCart.title': '자재 담기',
  'order.addToCart.checkLists.title': '필수 옵션',
  'order.addToCart.quantity.title': '자재 수량',
  'order.addToCart.footer.button': '장바구니 담기',
  'order.addToCart.footer.text': '옵션을 선택 및 입력해주세요',
  'order.addToCart.close': '나가기',
  'order.addToCart.stay': '마저 담기',
  'order.addToCart.popup.title': '잠깐! 상품을 아직 담지 않았습니다.',
  'order.addToCart.popup.sub': '이대로 담지 않고 나갈까요?',
  'order.addToCart.success': '장바구니에 상품을 담았습니다.',

  'order.detail.tab.info': '상품 상세 정보',
  'order.detail.tab.return': '반품 / 교환 정보',
  'order.detail.notice': '발주 요청에 맞추어 배송비가 책정됩니다.',
  'order.detail.notice.title': '상품 공지 사항',
  'order.detail.total.price': '총 상품 금액',
  'order.detail.quantity': '총 수량',
  'order.detail.notice.text': '알려드립니다',
  'order.detail.notice.text.1': '원활한 발주를 위해',
  'order.detail.notice.text.2': '구매는 상품을 담은 후 장바구니',
  'order.detail.notice.text.3': '에서 가능합니다.',

  'order.detail.info.tab.title': '상품 상세 정보',
  'order.detail.info.tab.origin': '원산지',
  'order.detail.info.tab.brand': '브랜드명',
  'order.detail.info.tab.thickness': '두께',
  'order.detail.info.tab.color': '컬러',
  'order.detail.info.tab.standard': '규격',
  'order.detail.info.tab.modelNumber': '모델품번',
  'order.detail.info.tab.type': '타입',
  'order.detail.info.tab.flameRetardant': '방염여부',
  'order.detail.info.tab.pcsBox': 'PCS/BOX',
  'order.detail.info.tab.certification': '인증서 유무',
  'order.detail.info.tab.m2Box': 'M2/BOX',
  'order.detail.info.tab.part': '부속폼 정보',
  'order.detail.info.tab.luminosity': '광도',
  'order.detail.info.tab.rawMaterial': '소재',
  'order.detail.info.tab.applicationArea': '적용부위',
  'order.detail.info.tab.information': '종합설명',

  'order.detail.checkList.required': '{name}은(는) 필수입력 항목입니다.\n옵션을 입력해주세요.',

  'order.detail.return.tab.title': '반품 / 교환\n요청 가능 기간',
  'order.detail.return.tab.subtitle.1': '단순 변심으로 인한 교환 / 반품 건에 한하여 수령 후 7일 이내 가능합니다.',
  'order.detail.return.tab.subtitle.2': '반품 / 교환\n불가 사유',
  'order.detail.return.tab.subtitle.3': '1. 요청기간이 지난 경우\n2. 소비자 귀책으로 상품이 멸실 또는 훼손된 경우\n3. 소비자 사용 또는 일부 소비로 상품 가치가 현저히 감소한 경우\n4. ',
  'order.detail.return.tab.subtitle.4': '고객 요청 사항에 맞춰 제작되는 맞춤 제작 상품의 경우',
  'order.detail.return.tab.subtitle.5': '\n· 제작 착수 후 청약철회 및 환불, 취소가 불가합니다.\n5. 그 외 관련 법령에 따라 청약철회가 제한되는 경우',

  'order.shopping.cart.material': '담은 자재',

  'order.shopping.cart.delete': '선택 삭제',
  'order.shopping.cart.select.all': '전체 선택',
  'order.shopping.cart.product': '상품',
  'order.shopping.cart.quantity.and.option': '수량 및 옵션',
  'order.shopping.cart.product.quantity': '상품 수량',
  'order.shopping.cart.modify': '주문 수정',
  'order.shopping.cart.discount': '특별 할인',

  'order.shopping.cart.remaining.quantity': '남은 수량',
  'order.shopping.cart.remaining.quantity.excess': '{count}개 초과',

  'order.shopping.cart.payment.title': '결제 예정금액',
  'common.vat': '부가세',
  'order.shopping.cart.delivery.fee': '배송비 (VAT포함)',
  'order.shopping.cart.delivery.fee.separate': '별도 청구',
  'order.shopping.cart.final.price': '최종금액',
  'order.shopping.cart.payment.notice.title': '결제 안내',
  'order.shopping.cart.payment.notice': '발주 요청 후 자재 공급처에서 재고 확인 및 배송비를 책정하면 결제할 수 있습니다.',
  'order.shopping.cart.order.request': '자재 발주',
  'order.shopping.cart.quantity': '{count}건',
  'order.shopping.cart.quantity.excess.popup.title': '예산 초과된 상품이 있습니다.',

  'order.shopping.cart.delete.popup.title': '상품을 장바구니에서 삭제할까요?',
  'order.confirm.remove.from.order.popup.title': '상품을 주문 상품에서 삭제할까요?',

  'order.complete.title': '발주 요청 완료',
  'order.complete.subtitle': '발주서가 접수되었습니다.\n재고 및 배송비가 확인되면 결제 요청 알림을 보내드립니다.',
  'order.complete.button': '자재주문 홈으로',
  'order.complete.time.title': '이용시간 안내',
  'order.complete.time.subtitle': '평일 08:30~17:30 / 토요일 : 08:30~10:30 / 공휴일 휴무',
  'order.complete.time.subtitle.2': '시간 외 주문하신 내용은 업무일 오전에 확인 후 처리됩니다.',
  'order.complete.select.material': '자재를 선택해주세요',
  'order.complete.field.name': '{fieldName}현장',
  'order.complete.field.change': '현장 변경',
  'order.complete.inspector.fill.current.user': '현재 로그인 정보로 채우기',
  'order.complete.field.name.title': '현장명',
  'order.complete.field.name.placeholder': '현장명을 입력해주세요(최대 15자)',
  'order.complete.field.address.title': '주소',
  'order.complete.field.address.placeholder': '주소지를 입력해주세요',
  'order.complete.field.address2.title': '상세 주소',
  'order.complete.field.address2.placeholder': '상세 주소를 입력해주세요',
  'order.complete.field.select.title': '현장 선택',
  'order.complete.field.select.button': '+ 새 현장 생성하기',

  'order.confirm.date.required.delivery.before.now': '희망 인수 일시를 확인해주세요',

  'customer.support.chat.button.alarm.text': '😄 답변이 도착했어요',
  'customer.support.chat.header.active.time': '몇분 이내로 답변 받으실 수 있어요',
  'customer.support.chat.header.inactive.time': '현재는 운영 시간이 아닙니다.',
  'common.end': '종료',

  'customer.support.chat.auto.reply.button.text': '모바일에서 확인해주세요',
  'customer.support.chat.notice.phone': '문의 전화 1644-4908',
  'customer.support.chat.notice.time': '월~금 08:30~17:30 (주말, 공휴일 제외)',

  'customer.support.chat.faq.title': '자주 묻는 질문',

  'customer.support.chat.daily.alarm.text.1': '자재 발주부터 사업 지원 서비스, ERP 사용 문의까지',
  'customer.support.chat.daily.alarm.text.2': '나야 상담원과 직접 소통하여 빠르게 해결하세요!',

  'material.area.empty.image.title': '이 상품들은 가격 정책으로\n현재 노출되지 않고 있습니다.',
  'material.area.empty.image.subtitle': '찾고 계신 자재를 아래로 요청해주시면\n귀사를 위한 단가로 견적서를 보내드려요',
  'material.area.empty.image.button': '견적단가 요청하기',

  'order.main.body.search.area.empty.title': '찾으시는 상품은 가격 정책으로 노출되지 않는 상품일 수 있습니다.',
  'order.main.body.search.area.empty.subtitle': '나야 채팅으로 요청해주시면 최적의 단가로 구성된 견적서를 보내드립니다!',
  'order.main.body.search.area.empty.button': '나야 채팅으로 요청하기',

  'order.main.body.promotion.title': '프로모션',
  'sidebar.field.setting': '현장설정',
  'customer.support.chat.title': '나야채팅',
  'order.main.body.promotion.link': 'https://www.nayac2y.com/event/?q=YToxOntzOjEyOiJrZXl3b3JkX3R5cGUiO3M6MzoiYWxsIjt9&bmode=view&idx=168501829&t=board',

  'order.detail.empty': '해당 상품이 존재하지 않습니다.',

  'order.shopping.cart.quantity.excess.popup.sub': '관리자에게 해당 자재 예산을\n추가 요청할까요?',

  'order.budget.request.complete': '요청 완료',
  'order.budget.request.memo.required': '필수 입력입니다.',

  // 견적/시장가 라벨 (임시 한국어, 베트남어 번역 필요)
  'material.specialDiscount': '특별할인',
  'material.eventPrice': '이벤트특가',

  'material.area.associated.image.title': '본 카테고리는 NICE 협회 회원사\n전용 특가 상품입니다.',
  'material.area.associated.image.subtitle': '아래 버튼을 눌러 협회 가입 후\n회원사 전용 특가 자재를 확인해보세요.',
  'material.area.associated.image.button': '협회 가입하기',

  // 베트남어 번역 필요 목록
  'dashboard.field.account.book.onboarding.start': '현장 손익 관리 시작하기',
  'dashboard.field.account.book.onboarding.title': '현장 손익 관리 시작하기',
  'dashboard.field.account.book.onboarding.description': '지금까지 진행했던 현장의 계약금\n지출, 수금 누계를 한번에 입력해보세요.',
  'dashboard.field.account.book.onboarding.vat.notice': '(VAT를 제외한 금액으로 입력하세요)',
  'dashboard.field.account.book.onboarding.sumExpenseBudget': '예산 (지출 총 목표 금액)',
  'dashboard.field.account.book.onboarding.skip.hint': '새로 시작하는 현장이라면 건너뛰어도 괜찮습니다',
  'dashboard.field.account.book.onboarding.submit': '현장 손익 관리 시작',
  'dashboard.field.account.book.onboarding.skip.confirm.title': '작성 중인 내용을 무시하고 건너뛸까요?',
  'dashboard.field.account.book.onboarding.skip.confirm.content': '현재 작성한 내용이 저장되지 않습니다.',
  'dashboard.field.account.book.onboarding.discard.title': '작성 중인 내용을 삭제할까요?',
  'dashboard.field.account.book.onboarding.discard.content': '삭제한 내용은 저장되지 않습니다.',
  'dashboard.field.account.book.onboarding.discard': '삭제',
};
